import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import DashboardTemplate from "../../Common/DashboardTemplate";
import {
    Checkbox,
    CircularProgress,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TablePagination,
    Paper,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Dialog,
    DialogContent,
    DialogActions,
    DialogTitle,
    Box,
    Modal,
    Typography,
    Radio,
    RadioGroup,
    FormControlLabel
} from "@material-ui/core";
import axios from 'axios';
import {ServiceLocator} from "../../../Services/ServiceLocator";
import DrawerMenuRight from "../../Common/DrawerMenuRight";
import { v4 as uuid } from 'uuid';
import Autocomplete from "@material-ui/lab/Autocomplete";
import { DatePicker, DateTimePicker } from '@material-ui/pickers';
import { format } from 'date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import dayjs from "dayjs";
import { toUtcForStorage, fromUtcForDisplay, getCurrentLocalTime, createDayjsForPicker, dayjsToDate, formatUtcForDisplay, dateTimePickerToUtc } from '../../../utils/dateUtils';
import { differenceInWeeks } from "date-fns";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencilAlt, faChevronUp, faChevronDown, faTrash, faInfoCircle, faPeopleCarry} from "@fortawesome/free-solid-svg-icons";
import {FilePond, registerPlugin} from 'react-filepond';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import PartAutocompleteOption from '../../Common/PartAutocompleteOption';
import PartDisplay from '../../Common/PartDisplay';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import 'filepond/dist/filepond.min.css';
import PackingSlip from "../../Common/PackingSlip";
import ReactDOM from 'react-dom';
import { AuthenticationService } from "../../../Services/AuthenticationService";
import { filterPersistenceService } from "../../../Services/FilterPersistenceService";
import {getNumberInputDisplayValue, parseNumberInputValue} from '../../../utils/numberInputUtils';
import {
    buildInTransitByPartId,
    computeCriticalEffectiveInventoryWeeks,
} from '../../../utils/inventoryCriticalUtils';
import SortableTableHeader from '../../Common/SortableTableHeader';
import {
    getNextSortState,
    sortCollectionWithContext,
    INVENTORY_LOG_SORT_ACCESSORS,
    sortPartsExpandedDefault,
} from '../../../utils/tableSortUtils';

registerPlugin(FilePondPluginFileValidateSize);
registerPlugin(FilePondPluginFileValidateType);

const styles = theme => ({
    wrapper: {
        margin: -5,
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    toolbarLeft: {
        display: 'flex',
        alignItems: 'center',
    },
    toolbarRight: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
    },
    filterToggle: {
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '2px 10px',
        height: '36px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
        minWidth: '150px',
        '& .MuiCheckbox-root': {
            padding: '0px',
            color: '#35d2d9',
            '&.Mui-checked': {
                color: '#35d2d9',
            },
        }
    },
    filterLabel: {
        marginLeft: '8px',
        fontSize: '14px',
        color: 'rgba(0, 0, 0, 0.87)',
    },
});

function addDays(date, days) {
    let result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

let adminUsers = [];
let inventoryLogs = [];
let parts = [];
let editingLog;
const UNIT_COST_DECIMALS = 6;
const MONEY_DECIMALS = 2;

const roundToDecimals = (value, decimals) => {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) return 0;
    const factor = 10 ** decimals;
    return Math.round((numericValue + Number.EPSILON) * factor) / factor;
};

const normalizeUnitCost = (value) => roundToDecimals(value, UNIT_COST_DECIMALS);
const normalizeMoney = (value) => roundToDecimals(value, MONEY_DECIMALS);
const calculateLineTotal = (unitCost, quantity) => normalizeMoney((Number(unitCost) || 0) * (Number(quantity) || 0));

/** Tiered per-unit price for an order quantity (aligned with handlePartQuantityChange / handleVendorChange). */
const getTieredUnitPriceForQuantity = (vendorPart, orderQuantity) => {
    if (!vendorPart || vendorPart.costType !== 0 || !vendorPart.tieredCostFormulas?.length) {
        return null;
    }
    const qty = Number(parseNumberInputValue(orderQuantity));
    const safeQty = Number.isFinite(qty) ? qty : 0;
    const sortedTiers = [...vendorPart.tieredCostFormulas].sort((a, b) => a.quantity - b.quantity);
    if (!sortedTiers.length) return null;
    const tier =
        safeQty < sortedTiers[0].quantity
            ? sortedTiers[0]
            : [...sortedTiers].reverse().find((t) => safeQty >= t.quantity) || sortedTiers[sortedTiers.length - 1];
    if (tier == null || tier.price === undefined) return null;
    return normalizeUnitCost(tier.price);
};

class AdminInventory extends React.Component {
    state = {
        loading: true,
        user: {},
        users: [],
        orders: [],
        reloads: [],
        transactions: [],
        parts: [],
        assemblies: [],
        subAssemblies: [],
        purchaseLogs: [],
        inventoryLogs: [],
        partFamilies: [],
        vendors: [],
        page: 0,
        rowsPerPage: 100,
        logsPage: 0,
        logsRowsPerPage: 100,
        logsSortField: 'logDate',
        logsSortDirection: 'desc',
        searchTerm: '',
        logsSearchTerm: '',
        newLogPart: null,
        newLogQuantity: 0,
        newLogReason: '',
        newLogDate: getCurrentLocalTime(),
        newLogDateManuallyChanged: false,
        newLogEntries: [],
        addingLogOpen: false,
        editingLog: null,
        editLogOpen: false,
        savingLog: false,
        deletingLog: false,
        selectedLogIds: [],
        lastSelectedLogIndex: null,
        isProcessingLogModifierClick: false,
        bulkEditDrawerOpen: false,
        bulkReason: '',
        bulkProcessing: false,
        newLogCompany: '',
        newLogQuantityReceived: 0,
        newLogReceivedDate: getCurrentLocalTime(),
        newLogIsPaid: false,
        newLogIsReceived: false,
        newLogParts: [],
        newPurchaseOrderDate: getCurrentLocalTime(),
        selectedParts: {},
        purchaseDrawerOpen: false,
        newVendorOrderNumber: '',
        permissions: [],
        invoiceFiles: [],
        packingSlipFiles: [],
        purchasePartsSearchTerm: '',
        showAdvancedInfo: false,
        showCopyTable: false,
        copyTableData: [],
        copyTablesByVendor: {},
        overriddenQuantities: {},
        purchaseDrawerParts: [],
        // Session-related state
        sessionDrawerOpen: false,
        sessionNumber: 1,
        loadingNextSessionId: false,
        // Filter state
        showNonInventoryItems: false,
        showLowInventoryOnly: false,
        showCriticalEffectiveInventoryOnly: false,
        showOnlyPurchasing: false,
        inTransitByPartId: {},
        // Order calculation state
        orderCalculationMethod: 'targetDate', // 'targetDate' or 'desiredWeeks'
        targetDate: getCurrentLocalTime().add(10, 'week'), // Default to 10 weeks from today
        weeksToOrderBuffer: 1, // Buffer weeks for desired weeks calculation
        desiredWeeksForOrder: 10, // Weeks value for desired weeks calculation
    };

    handleChangePage = (event, newPage) => {
        this.setState({page: newPage}, () => {
            this.saveFilterSettings();
        });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, () => {
            this.saveFilterSettings();
        });
        this.setState({page: 0});
    };

    constructor(props) {
        super(props);
        globalProps = props;

        const authService = AuthenticationService.getInstance();
        const token = authService.getToken();
        if (token) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        }
    }

    componentDidMount() {
        this.loadSavedFilterSettings();
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        // Handle URL changes to maintain logs view state
        if (prevProps.location?.pathname !== this.props.location?.pathname) {
            const shouldShowLogs = this.props.location?.pathname?.includes('logs') || false;
            if (this.state.showingLogs !== shouldShowLogs) {
                this.setState({ showingLogs: shouldShowLogs });
            }
        }
    }
    loadSavedFilterSettings = () => {
        const savedSettings = filterPersistenceService.loadFilterSettings('inventory');
        const showOnlyPurchasing = savedSettings?.showOnlyPurchasing || false;
        
        if (savedSettings) {
            this.setState({
                page: savedSettings.page || 0,
                rowsPerPage: savedSettings.rowsPerPage || 100,
                searchTerm: savedSettings.searchTerm || '',
                showAdvancedInfo: savedSettings.showAdvancedInfo || false,
                showDeactivated: savedSettings.showDeactivated || false,
                showOldRevs: savedSettings.showOldRevs || false,
                showNonInventoryItems: savedSettings.showNonInventoryItems || false,
                showLowInventoryOnly: savedSettings.showLowInventoryOnly || false,
                showCriticalEffectiveInventoryOnly: savedSettings.showCriticalEffectiveInventoryOnly || false,
                showOnlyPurchasing: showOnlyPurchasing,
                orderCalculationMethod: savedSettings.orderCalculationMethod || 'targetDate',
                targetDate: savedSettings.targetDate ? dayjs(savedSettings.targetDate) : dayjs(new Date(Date.now() + 10 * 7 * 24 * 60 * 60 * 1000)),
                weeksToOrderBuffer: savedSettings.weeksToOrderBuffer || 1,
                desiredWeeksForOrder: savedSettings.desiredWeeksForOrder || 10
            });
        }
        
        // Load saved purchase state and check if filter should be disabled
        this.loadSavedPurchaseState(showOnlyPurchasing);
    }
    
    loadSavedPurchaseState = (showOnlyPurchasingFromSettings = false) => {
        try {
            const savedPurchaseState = localStorage.getItem('inventory_purchase_state');
            let selectedParts = {};
            
            if (savedPurchaseState) {
                const parsedState = JSON.parse(savedPurchaseState);
                selectedParts = parsedState.selectedParts || {};
                this.setState({
                    selectedParts: selectedParts,
                    overriddenQuantities: parsedState.overriddenQuantities || {},
                    newLogParts: parsedState.newLogParts || []
                }, () => {
                    // If filter is enabled but no parts are selected, disable the filter
                    if (showOnlyPurchasingFromSettings && Object.keys(selectedParts).length === 0) {
                        this.setState({ showOnlyPurchasing: false }, () => {
                            this.saveFilterSettings();
                        });
                    }
                });
            } else {
                // Even if no saved purchase state, check if filter should be disabled
                if (showOnlyPurchasingFromSettings && Object.keys(selectedParts).length === 0) {
                    this.setState({ showOnlyPurchasing: false }, () => {
                        this.saveFilterSettings();
                    });
                }
            }
        } catch (error) {
            console.warn('Failed to load saved purchase state:', error);
            // On error, also check if filter should be disabled
            if (showOnlyPurchasingFromSettings && Object.keys(this.state.selectedParts).length === 0) {
                this.setState({ showOnlyPurchasing: false }, () => {
                    this.saveFilterSettings();
                });
            }
        }
    }
    
    savePurchaseState = () => {
        try {
            const purchaseState = {
                selectedParts: this.state.selectedParts,
                overriddenQuantities: this.state.overriddenQuantities,
                newLogParts: this.state.newLogParts || []
            };
            localStorage.setItem('inventory_purchase_state', JSON.stringify(purchaseState));
        } catch (error) {
            console.warn('Failed to save purchase state:', error);
        }
    }
    
    clearPurchaseState = () => {
        try {
            localStorage.removeItem('inventory_purchase_state');
        } catch (error) {
            console.warn('Failed to clear purchase state:', error);
        }
    }
    
    clearSavedPurchaseState = () => {
        this.clearPurchaseState();
        this.setState({
            selectedParts: {},
            overriddenQuantities: {},
            newLogParts: [],
            showOnlyPurchasing: false // Disable filter when clearing selections
        }, () => {
            this.saveFilterSettings();
        });
        window.$alertSuccess('Purchase state cleared successfully');
    }

    saveFilterSettings = () => {
        const settings = {
            page: this.state.page,
            rowsPerPage: this.state.rowsPerPage,
            searchTerm: this.state.searchTerm,
            showAdvancedInfo: this.state.showAdvancedInfo,
            showDeactivated: this.state.showDeactivated,
            showOldRevs: this.state.showOldRevs,
            showNonInventoryItems: this.state.showNonInventoryItems,
            showLowInventoryOnly: this.state.showLowInventoryOnly,
            showCriticalEffectiveInventoryOnly: this.state.showCriticalEffectiveInventoryOnly,
            showOnlyPurchasing: this.state.showOnlyPurchasing,
            orderCalculationMethod: this.state.orderCalculationMethod,
            targetDate: this.state.targetDate.toDate(),
            weeksToOrderBuffer: this.state.weeksToOrderBuffer,
            desiredWeeksForOrder: this.state.desiredWeeksForOrder
        };
        filterPersistenceService.saveFilterSettings('inventory', settings);
    }

    loadData = () => {
        const self = this;
        const user = AuthenticationService.getInstance().getUser();
        if (!user || !user.userPermissions || !user.userPermissions.includes('Purchase')) {
            globalProps.history.push('/login');
            return;
        }

        self.setState({loading: true});
        Promise.all([self.loadVendors(), self.loadAdminUsers(), self.loadAssemblies(), self.loadSubAssemblies(), self.loadParts(), self.loadPurchaseLogs(), self.loadInventoryLogs(), self.loadPartFamilies()]).then(() => {
            // Preserve showingLogs state if already true, otherwise check URL
            const shouldShowLogs = self.state.showingLogs || globalProps.location.pathname.includes('logs');
            self.setState({showingLogs: shouldShowLogs, loading: false, user, adminUsers, inventoryLogs, permissions: user.userPermissions}, () => {
                self.syncSelectedPartsQuantitiesFromCalculation();
            });
            // Focus search bar after render
            setTimeout(() => {
                if (this.searchInputRef) {
                    this.searchInputRef.focus();
                }
            }, 100);
        });
    };

    loadAdminUsers = () => {
        const userService = ServiceLocator.Instance.getUserService();
        return userService.getAdminUsers().then((adminUsersResult) => {
            adminUsers = adminUsersResult;
        });
    };

    loadVendors = () => {
        const partService = ServiceLocator.Instance.getPartService();
        return partService.getAllVendors().then((vendors) => {
            this.setState({vendors});
        })
    };

    loadParts = () => {
        const self = this;
        const partService = ServiceLocator.Instance.getPartService();

        return partService.getAllPartsExpanded().then((partsResult) => {
            parts = sortPartsExpandedDefault(partsResult);
            self.setState({parts});
        });
    };

    loadAssemblies = () => {
        const self = this;
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getAllAssembliesExpanded().then((assemblies) => {
            self.setState({assemblies});
        });
    };

    loadSubAssemblies = () => {
        const self = this;
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getAllSubAssembliesExpanded().then((subAssemblies) => {
            self.setState({subAssemblies});
        });
    };

    loadPurchaseLogs = () => {
        const self = this;
        const partService = ServiceLocator.Instance.getPartService();
        return Promise.all([
            partService.getPurchaseLogs(),
            partService.getAllPackingSlips(),
        ]).then(([purchaseLogs, packingSlips]) => {
            purchaseLogs = purchaseLogs.sort(function (a, b) {
                return new Date(b.orderDate) - new Date(a.orderDate);
            });
            const inTransitByPartId = buildInTransitByPartId(purchaseLogs, packingSlips);
            self.setState({ purchaseLogs, inTransitByPartId });
        });
    };

    loadInventoryLogs = () => {
        const partService = ServiceLocator.Instance.getPartService();
        return partService.getInventoryLogs().then((inventoryLogsResult) => {
            inventoryLogs = inventoryLogsResult.sort(function (a, b) {
                return new Date(b.logDate) - new Date(a.logDate);
            });
        });
    };

    loadPartFamilies = () => {
        const partService = ServiceLocator.Instance.getPartService();
        return partService.getPartFamilies().then((partFamilies) => {
            this.setState({partFamilies});
        });
    };

    editPart = (partExpanded, newTab) => {
        if (newTab)
            window.open(`/admin/parts/${partExpanded.part.id}`);
        else
            globalProps.history.push(`/admin/parts/${partExpanded.part.id}`);
    };

    searchPart = (event) => {
        const searchTerm = event.target.value;
        this.setState({searchTerm: searchTerm, page: 0}, () => {
            this.saveFilterSettings();
        });
    };

    searchLogs = (event) => {
        const searchTerm = event.target.value;
        this.setState({logsSearchTerm: searchTerm, logsPage: 0});
    };

    handleLogsChangePage = (event, newPage) => {
        this.setState({logsPage: newPage});
    };

    handleLogsChangeRowsPerPage = (event) => {
        this.setState({logsRowsPerPage: parseInt(event.target.value, 10)});
        this.setState({logsPage: 0});
    };

    changeQuantity = (event) => {
        this.setState({newLogQuantity: event.target.value});
    };

    changeReason = (event) => {
        this.setState({newLogReason: event.target.value});
    };

    openAddLog = () => {
        this.setState({
            addingLogOpen: true,
            savingLog: false,
            newLogEntries: [{
                id: uuid(),
                part: null,
                quantity: 0
            }]
        });
    };

    handleCloseNewLog = () => {
        this.setState({
            addingLogOpen: false,
            newLogPart: null,
            newLogQuantity: 0,
            newLogReason: '',
            newLogDate: dayjs(new Date()),
            newLogDateManuallyChanged: false,
            newLogEntries: []
        });
    };

    handleNewLogPartChange = (index, newValue) => {
        if (!newValue) {
            const entries = [...this.state.newLogEntries];
            entries[index].part = null;
            this.setState({ newLogEntries: entries });
            return;
        }
        const entries = [...this.state.newLogEntries];
        if (newValue.isFamily) {
            entries[index].part = { title: newValue.title, value: newValue.value, isFamily: true };
        } else {
            entries[index].part = { title: newValue.title, value: newValue.value, isFamily: false };
        }
        if (index === entries.length - 1 && entries[index].part) {
            entries.push({ id: uuid(), part: null, quantity: 0 });
        }
        this.setState({ newLogEntries: entries }, () => {
            if (entries[index].part) {
                setTimeout(() => {
                    const quantityField = document.querySelector(`[data-inventory-entry-index="${index}"] input[type="number"]`);
                    if (quantityField) {
                        quantityField.focus();
                        quantityField.select();
                    }
                }, 100);
            }
        });
    };

    handleNewLogQuantityChange = (index, event) => {
        const entries = [...this.state.newLogEntries];
        entries[index].quantity = event.target.value;
        this.setState({ newLogEntries: entries });
    };

    handleNewLogQuantityKeyDown = (index, event) => {
        if (event.key === 'Tab' || event.key === 'Enter') {
            if (!event.shiftKey) {
                event.stopPropagation();
                event.preventDefault();
                if (index === this.state.newLogEntries.length - 1 && this.state.newLogEntries[index].part) {
                    const entries = [...this.state.newLogEntries];
                    entries.push({ id: uuid(), part: null, quantity: 0 });
                    this.setState({ newLogEntries: entries }, () => {
                        setTimeout(() => {
                            const newPartInput = document.querySelector(`[data-inventory-entry-index="${entries.length - 1}"] input`);
                            if (newPartInput) newPartInput.focus();
                        }, 100);
                    });
                } else if (index < this.state.newLogEntries.length - 1) {
                    setTimeout(() => {
                        const nextPartInput = document.querySelector(`[data-inventory-entry-index="${index + 1}"] input`);
                        if (nextPartInput) nextPartInput.focus();
                    }, 100);
                }
            }
        }
    };

    removeNewLogEntry = (index) => {
        const entries = [...this.state.newLogEntries];
        entries.splice(index, 1);
        if (entries.length === 0) {
            entries.push({ id: uuid(), part: null, quantity: 0 });
        }
        this.setState({ newLogEntries: entries });
    };

    handlePartChange = (event, newValue) => {
        if (!newValue) {
            this.setState({newLogPart: null});
            return;
        }

        // Check if the selected item is a family
        if (newValue.isFamily) {
            // If it's already a family, use it directly
            this.setState({newLogPart: newValue.value});
            return;
        }

        // Check if the selected part belongs to a family
        const selectedPart = this.state.parts.find(part => part.part.id === newValue.value);
        if (selectedPart && selectedPart.part.partToFamilies && selectedPart.part.partToFamilies.length > 0) {
            // Only select the family if the part belongs to exactly one family
            if (selectedPart.part.partToFamilies.length === 1) {
                const familyId = selectedPart.part.partToFamilies[0].familyId;
                const family = this.state.partFamilies.find(f => f.id === familyId);
                
                if (family) {
                    // Automatically select the family instead of the individual part
                    const familyValue = { title: `${family.partFamilyId} (Family)`, value: family.id, isFamily: true };
                    this.setState({
                        newLogPart: familyValue
                    });
                    return;
                }
            }
            // If part belongs to multiple families, select the part directly
        }

        // If no family found or part doesn't belong to a family, use the part directly
        this.setState({newLogPart: newValue.value});
    };

    addInventoryLog = () => {
        const self = this;
        const validEntries = this.state.newLogEntries.filter(entry => entry.part);
        if (validEntries.length === 0) return window.$alertWarning("You must select at least one part for this log");

        self.setState({savingLog: true});
        const partService = ServiceLocator.Instance.getPartService();
        const logDate = this.state.newLogDateManuallyChanged
            ? dateTimePickerToUtc(this.state.newLogDate)
            : dateTimePickerToUtc(dayjs().toDate());
        const reason = this.state.newLogReason;
        const userId = AuthenticationService.getInstance().getUserId();

        const collectPromises = (promises, entry) => {
            const isFamily = entry.part && entry.part.isFamily;
            const qty = parseNumberInputValue(entry.quantity);
            if (isFamily) {
                const familyId = entry.part.value;
                return partService.getPartFamilyRelationships(familyId).then((relationships) => {
                    const filtered = (relationships || []).filter(r => !r.isImpliedPart);
                    if (filtered.length === 0) {
                        window.$alertWarning(`Family contains no parts`);
                        return;
                    }
                    filtered.forEach(relationship => {
                        const purchaseQuantity = parseInt(relationship.purchaseQuantity, 10) || 1;
                        const payload = {
                            id: uuid(),
                            quantity: purchaseQuantity * qty,
                            reason,
                            partId: relationship.partId,
                            logDate,
                            userId
                        };
                        promises.push(partService.createInventoryLog(payload));
                    });
                });
            } else {
                const partId = entry.part.value;
                const payload = {
                    id: uuid(),
                    quantity: qty,
                    reason,
                    partId,
                    logDate,
                    userId
                };
                promises.push(partService.createInventoryLog(payload));
            }
        };

        const promises = [];
        const entryPromises = [];
        validEntries.forEach(entry => {
            const p = collectPromises.call(this, promises, entry);
            if (p && typeof p.then === 'function') entryPromises.push(p);
        });

        Promise.all(entryPromises).then(() => {
            return Promise.all(promises);
        }).then(() => {
            const count = promises.length;
            window.$alertSuccess(count === 1 ? "Inventory log created" : `${count} inventory logs created`);
            self.setState({
                addingLogOpen: false,
                savingLog: false,
                newLogEntries: [{ id: uuid(), part: null, quantity: 0 }]
            });
            self.loadData();
        }).catch((error) => {
            console.error('Error creating inventory logs:', error);
            window.$alertError("Error creating inventory logs");
            self.setState({savingLog: false});
        });
    };

    editLog = (inventoryLog) => {
        editingLog = inventoryLog;
        this.setState({
            editingLog, 
            editingLogOriginal: JSON.parse(JSON.stringify(inventoryLog)), // Store original for comparison
            editLogOpen: true
        });
    };

    editQuantity = (event) => {
        editingLog.quantity = event.target.value;
        this.setState({editingLog});
    };

    editReason = (event) => {
        editingLog.reason = event.target.value;
        this.setState({editingLog});
    };

    editLogPart = (event, newValue) => {
        if (newValue) {
            editingLog.partId = newValue.part.id;
        }
        this.setState({editingLog});
    };

    saveInventoryLog = () => {
        const self = this;
        self.setState({savingLog: true});
        const partService = ServiceLocator.Instance.getPartService();
        
        // Check if the logDate has been modified by the user
        // If it's the same as the original, it's already UTC from the database
        // If it's different, it's a new local time from the DateTimePicker
        let logDateToSave;
        if (this.state.editingLogOriginal && 
            this.state.editingLog.logDate === this.state.editingLogOriginal.logDate) {
            // Date hasn't been changed, use the original UTC date
            logDateToSave = this.state.editingLogOriginal.logDate;
        } else {
            // Date has been changed, convert the new local time to UTC
            logDateToSave = dateTimePickerToUtc(this.state.editingLog.logDate);
        }
        
        const logToSave = {
            ...editingLog,
            logDate: logDateToSave
        };
        partService.updateInventoryLog(logToSave).then(() => {
            window.$alertSuccess("Inventory log saved");
            self.setState({editLogOpen: false, savingLog: false});
            self.loadData();
        });
    }

    deleteInventoryLog = () => {
        const self = this;
        
        // Confirm deletion
        if (!window.confirm('Are you sure you want to delete this inventory log? This action cannot be undone.')) {
            return;
        }
        
        self.setState({deletingLog: true});
        const partService = ServiceLocator.Instance.getPartService();
        partService.deleteInventoryLog(editingLog.id).then(() => {
            window.$alertSuccess("Inventory log deleted");
            self.setState({editLogOpen: false, deletingLog: false});
            self.loadData();
        }).catch((error) => {
            console.error('Error deleting inventory log:', error);
            window.$alertError("Error deleting inventory log");
            self.setState({deletingLog: false});
        });
    }

    handleCloseEditLog = () => {
        this.setState({editingLog: null, editingLogOriginal: null, editLogOpen: false, deletingLog: false});
    };

    hasEditLogUnsavedChanges = () => {
        if (!this.state.editingLog || !this.state.editingLogOriginal) return false;
        
        const current = this.state.editingLog;
        const original = this.state.editingLogOriginal;
        
        return (
            current.quantity !== original.quantity ||
            current.reason !== original.reason
        );
    };

    // Returns the inventory logs currently visible in the logs table (search + visibility filters applied)
    getFilteredInventoryLogs = () => {
        const logsSearchTerm = this.state.logsSearchTerm;
        const searchTerm = (logsSearchTerm || '').toLowerCase();
        const filtered = this.state.inventoryLogs.filter(inventoryLog => {
            // Hide logs with quantity 0 (confirmation logs from inventory sessions)
            if (inventoryLog.quantity === 0) return false;
            const part = this.state.parts.find(x => x.part.id === inventoryLog.partId);
            if (!part) return false;
            if (!logsSearchTerm) return true;
            const adminUser = this.state.adminUsers.find(x => x.id === inventoryLog.userId);
            const userName = adminUser ? `${adminUser.firstName} ${adminUser.lastName}` : 'Unknown';
            return (part.part.partId || '').toLowerCase().includes(searchTerm) ||
                   (part.part.description || '').toLowerCase().includes(searchTerm) ||
                   userName.toLowerCase().includes(searchTerm) ||
                   (inventoryLog.reason || '').toLowerCase().includes(searchTerm) ||
                   inventoryLog.quantity.toString().includes(logsSearchTerm);
        });

        return sortCollectionWithContext(
            filtered,
            this.state.logsSortField,
            this.state.logsSortDirection,
            INVENTORY_LOG_SORT_ACCESSORS,
            { parts: this.state.parts, adminUsers: this.state.adminUsers }
        );
    };

    handleInventoryLogsSort = (field) => {
        this.setState((prevState) => {
            const next = getNextSortState(prevState.logsSortField, prevState.logsSortDirection, field);
            return {
                logsSortField: next.field,
                logsSortDirection: next.direction,
                logsPage: 0,
            };
        });
    };

    handleSelectAllLogs = (event) => {
        const checked = event.target.checked;
        const allFilteredIds = this.getFilteredInventoryLogs().map(log => log.id);
        if (checked) {
            this.setState({
                selectedLogIds: [...new Set([...this.state.selectedLogIds, ...allFilteredIds])]
            });
        } else {
            this.setState({
                selectedLogIds: this.state.selectedLogIds.filter(id => !allFilteredIds.includes(id))
            });
        }
    };

    handleSelectLog = (logId, event) => {
        const processedData = this.getFilteredInventoryLogs();
        const currentIndex = processedData.findIndex(log => log.id === logId);
        const isCurrentlySelected = this.state.selectedLogIds.includes(logId);

        const isCtrlPressed = (event && (event.ctrlKey || event.metaKey)) ||
                             (event.nativeEvent && (event.nativeEvent.ctrlKey || event.nativeEvent.metaKey));
        const isShiftPressed = (event && event.shiftKey) ||
                               (event.nativeEvent && event.nativeEvent.shiftKey);

        const hasModifiers = isCtrlPressed || isShiftPressed;
        if (hasModifiers) {
            this.setState({ isProcessingLogModifierClick: true });
            if (event && event.preventDefault) event.preventDefault();
            if (event && event.stopPropagation) event.stopPropagation();
        }

        if (currentIndex === -1) {
            this.setState({
                selectedLogIds: isCurrentlySelected
                    ? this.state.selectedLogIds.filter(id => id !== logId)
                    : [...this.state.selectedLogIds, logId],
                lastSelectedLogIndex: null
            });
            return;
        }

        if (isShiftPressed && this.state.lastSelectedLogIndex !== null && this.state.lastSelectedLogIndex !== -1) {
            const startIndex = Math.min(this.state.lastSelectedLogIndex, currentIndex);
            const endIndex = Math.max(this.state.lastSelectedLogIndex, currentIndex);
            const rangeIds = processedData.slice(startIndex, endIndex + 1).map(log => log.id);
            if (isCtrlPressed) {
                const allInRangeSelected = rangeIds.every(id => this.state.selectedLogIds.includes(id));
                this.setState({
                    selectedLogIds: allInRangeSelected
                        ? this.state.selectedLogIds.filter(id => !rangeIds.includes(id))
                        : [...new Set([...this.state.selectedLogIds, ...rangeIds])],
                    lastSelectedLogIndex: currentIndex
                });
            } else {
                this.setState({
                    selectedLogIds: [...new Set([...this.state.selectedLogIds, ...rangeIds])],
                    lastSelectedLogIndex: currentIndex
                });
            }
        } else {
            this.setState({
                selectedLogIds: isCurrentlySelected
                    ? this.state.selectedLogIds.filter(id => id !== logId)
                    : [...this.state.selectedLogIds, logId],
                lastSelectedLogIndex: currentIndex
            });
        }

        if (hasModifiers) {
            setTimeout(() => {
                this.setState({ isProcessingLogModifierClick: false });
            }, 100);
        }
    };

    clearLogSelection = () => {
        this.setState({ selectedLogIds: [], lastSelectedLogIndex: null });
    };

    openBulkEditDrawer = () => {
        if (this.state.selectedLogIds.length === 0) return;
        this.setState({ bulkEditDrawerOpen: true, bulkReason: '' });
    };

    handleCloseBulkEditDrawer = () => {
        if (this.state.bulkProcessing) return;
        this.setState({ bulkEditDrawerOpen: false });
    };

    changeBulkReason = (event) => {
        this.setState({ bulkReason: event.target.value });
    };

    applyBulkReason = () => {
        const self = this;
        const ids = this.state.selectedLogIds;
        if (ids.length === 0) return;
        const reason = this.state.bulkReason;
        // Blank = no change, mirroring the Sales bulk edit behavior
        if (reason === '') {
            self.setState({ bulkEditDrawerOpen: false });
            return;
        }
        const partService = ServiceLocator.Instance.getPartService();
        const logsById = {};
        this.state.inventoryLogs.forEach(log => { logsById[log.id] = log; });
        self.setState({ bulkProcessing: true });
        Promise.all(ids.map(id => {
            const log = logsById[id];
            if (!log) return Promise.resolve();
            // logDate came from the DB already in UTC; send it back unchanged
            return partService.updateInventoryLog({ ...log, reason });
        })).then(() => {
            window.$alertSuccess(`Updated reason on ${ids.length} log${ids.length === 1 ? '' : 's'}`);
            self.setState({ bulkEditDrawerOpen: false, bulkProcessing: false, selectedLogIds: [], lastSelectedLogIndex: null });
            self.loadData();
        }).catch((error) => {
            console.error('Error updating inventory logs:', error);
            window.$alertError("Error updating inventory logs");
            self.setState({ bulkProcessing: false });
        });
    };

    bulkDeleteLogs = () => {
        const self = this;
        const ids = this.state.selectedLogIds;
        if (ids.length === 0) return;
        if (!window.confirm(`Are you sure you want to delete ${ids.length} inventory log${ids.length === 1 ? '' : 's'}? This action cannot be undone.`)) {
            return;
        }
        const partService = ServiceLocator.Instance.getPartService();
        self.setState({ bulkProcessing: true });
        Promise.all(ids.map(id => partService.deleteInventoryLog(id))).then(() => {
            window.$alertSuccess(`Deleted ${ids.length} inventory log${ids.length === 1 ? '' : 's'}`);
            self.setState({ bulkProcessing: false, selectedLogIds: [], lastSelectedLogIndex: null });
            self.loadData();
        }).catch((error) => {
            console.error('Error deleting inventory logs:', error);
            window.$alertError("Error deleting inventory logs");
            self.setState({ bulkProcessing: false });
        });
    };

    changePurchaseQuantity = (newQuantity) => {
        const partExpanded = this.state.parts.find(x => x.part.id === this.state.newPurchaseLogPart);
        let unitCost = partExpanded ? partExpanded.cost : 0.00;
        let pricePaid = calculateLineTotal(unitCost, newQuantity).toFixed(2);
        this.setState({newPurchaseLogQuantity: newQuantity, newLogPricePaid: pricePaid});
    };

    changePurchaseQuantityReceived = (event) => {
        this.setState({newPurchaseLogQuantityReceived: event.target.value});
    };

    openAddPurchaseLog = (partId) => {
        const loggingPart = parts.find(x => x.part.id === partId).part;
        loggingPart.vendorParts.forEach((vendorPart) => {
            vendorPart.vendorName = this.state.vendors.find(x => x.id === vendorPart.vendorId).name;
        });
        loggingPart.vendorsList = loggingPart.vendorParts.map((vendor) => vendor.vendorName);
        this.setState({purchaseDrawerOpen: true, savingPurchaseLog: false, newPurchaseLogPart: partId});
    };

    changeCompany = (vendor) => {
        this.setState({newPurchaseLogCompany: vendor, customVendor: vendor === "Other..."});
    };

    changeCustomCompany = (vendor) => {
        this.setState({newPurchaseLogCompany: vendor});
    };

    handleCloseNewPurchaseLog = () => {
        this.setState({purchaseDrawerOpen: false});
    };

    changePurchaseCompany = (event) => {
        this.setState({newPurchaseLogCompany: event.target.value});
    };

    addPurchaseLog = () => {
        const self = this;
        if (!this.state.newPurchaseLogPart || this.state.newPurchaseLogCompany === '') return window.$alertWarning("You must select a company and part for this log");

        self.setState({savingPurchaseLog: true});

        const orderId = uuid();

        const newLogParts = [{
            id: uuid(),
            companyName: this.state.newPurchaseLogCompany,
            quantity: parseNumberInputValue(this.state.newPurchaseLogQuantity),
            quantityReceived: parseNumberInputValue(this.state.newPurchaseLogQuantityReceived),
            partId: this.state.newPurchaseLogPart,
            isPaid: this.state.newPurchaseLogIsPaid,
            pricePaid: this.state.newPurchaseLogIsPaid ? parseNumberInputValue(this.state.newLogPricePaid) : 0.00,
            orderDate: this.state.newPurchaseLogOrderDate,
            orderId: orderId,
            receivedDate: this.state.newPurchaseLogIsReceived ? this.state.newPurchaseLogIsReceived : null
        }];

                    const purchaseOrder = {
                id: orderId,
                placedOn: this.state.newPurchaseLogOrderDate,
                vendorOrderNumber: this.state.newVendorOrderNumber,
                pricePaid: normalizeMoney(parts.reduce((sum, part) => sum + (part.isPaid ? part.pricePaid : 0), 0)),
                invoices: [],
                packingSlips: [],
                purchasedParts: newLogParts,
                userId: AuthenticationService.getInstance().getUserId()
            };

        const partService = ServiceLocator.Instance.getPartService();
        partService.createPurchaseOrder(purchaseOrder).then((purchaseOrder) => {
            this.setState({selectedPurchaseOrderId: purchaseOrder.id});
            window.$alertSuccess("Purchase log created");
            self.clearPurchaseState(); // Clear localStorage purchase checkboxes
            self.setState({
                purchaseDrawerOpen: false, 
                savingPurchaseLog: false,
                selectedParts: {}, // Clear selected parts from component state
                overriddenQuantities: {}, // Clear overridden quantities
                newLogParts: [] // Clear new log parts
            });
            self.loadData();
        });
    };

    handlePartSelection = (partId, quantity) => {
        const selectedParts = { ...this.state.selectedParts };
        if (quantity > 0) {
            selectedParts[partId] = quantity;
        } else {
            delete selectedParts[partId];
        }
        // If no parts are selected, disable the "Show Only Purchasing" filter
        const previousShowOnlyPurchasing = this.state.showOnlyPurchasing;
        const showOnlyPurchasing = Object.keys(selectedParts).length > 0 ? this.state.showOnlyPurchasing : false;
        this.setState({ selectedParts, showOnlyPurchasing }, () => {
            this.savePurchaseState();
            if (showOnlyPurchasing !== previousShowOnlyPurchasing) {
                this.saveFilterSettings();
            }
        });
    };

    handleQuantityOverride = (partId, value) => {
        const overriddenQuantities = { ...this.state.overriddenQuantities };
        const selectedParts = { ...this.state.selectedParts };

        if (value === '' || value === null || value === '0') {
            delete overriddenQuantities[partId];
            delete selectedParts[partId];
        } else {
            const numValue = parseInt(value);
            if (!isNaN(numValue)) {
                overriddenQuantities[partId] = numValue;
                if (numValue > 0) {
                    selectedParts[partId] = numValue;
                } else {
                    delete selectedParts[partId];
                }
            }
        }
        // If no parts are selected, disable the "Show Only Purchasing" filter
        const previousShowOnlyPurchasing = this.state.showOnlyPurchasing;
        const showOnlyPurchasing = Object.keys(selectedParts).length > 0 ? this.state.showOnlyPurchasing : false;
        this.setState({ overriddenQuantities, selectedParts, showOnlyPurchasing }, () => {
            this.savePurchaseState();
            if (showOnlyPurchasing !== previousShowOnlyPurchasing) {
                this.saveFilterSettings();
            }
        });
    };

    handleWorksheetQuantityKeyDown = (event, currentPartId) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            const filteredParts = this.getFilteredPurchaseParts();
            const currentIndex = filteredParts.findIndex(partExpanded => partExpanded.part.id === currentPartId);
            
            if (currentIndex !== -1 && currentIndex < filteredParts.length - 1) {
                // Find the next part's quantity TextField
                const nextPartId = filteredParts[currentIndex + 1].part.id;
                const nextTextField = document.querySelector(`input[data-part-id="worksheet-${nextPartId}"]`);
                
                if (nextTextField) {
                    nextTextField.focus();
                    nextTextField.select();
                }
            }
        }
    };

    handleQuantityKeyDown = (event, currentPartId) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            
            // Get the current filtered parts
            const filteredParts = this.getFilteredPurchaseParts();
            const currentIndex = filteredParts.findIndex(partExpanded => partExpanded.part.id === currentPartId);
            
            if (currentIndex !== -1 && currentIndex < filteredParts.length - 1) {
                // Find the next part's quantity TextField
                const nextPartId = filteredParts[currentIndex + 1].part.id;
                const nextTextField = document.querySelector(`input[data-part-id="${nextPartId}"]`);
                
                if (nextTextField) {
                    nextTextField.focus();
                    nextTextField.select();
                }
            }
        }
    };

    // Session-related methods
    openSessionDrawer = async () => {
        this.setState({ sessionDrawerOpen: true, loadingNextSessionId: true });
        await this.loadNextSessionId();
        this.setState({ loadingNextSessionId: false });
    };

    closeSessionDrawer = () => {
        this.setState({ sessionDrawerOpen: false });
    };

    loadNextSessionId = async () => {
        try {
            const assemblyService = ServiceLocator.Instance.getAssemblyService();
            const partService = ServiceLocator.Instance.getPartService();
            
            // Get all package logs and inventory logs
            const [packageLogs, inventoryLogs] = await Promise.all([
                assemblyService.getPackageLogs(),
                partService.getInventoryLogs()
            ]);
            
            // Filter for inventory session logs and extract session numbers
            const sessionNumbers = [];
            
            // Check package logs for session patterns
            packageLogs.forEach(log => {
                if (log.reason && log.reason.startsWith('Inventory Session ')) {
                    const sessionMatch = log.reason.match(/Inventory Session (\d+)/);
                    if (sessionMatch) {
                        sessionNumbers.push(parseInt(sessionMatch[1]));
                    }
                }
            });
            
            // Check inventory logs for session patterns
            inventoryLogs.forEach(log => {
                if (log.reason && log.reason.startsWith('Inventory Session ')) {
                    const sessionMatch = log.reason.match(/Inventory Session (\d+)/);
                    if (sessionMatch) {
                        sessionNumbers.push(parseInt(sessionMatch[1]));
                    }
                }
            });
            
            // Find the highest session number and add 1
            const maxSessionNumber = sessionNumbers.length > 0 ? Math.max(...sessionNumbers) : 0;
            const nextSessionNumber = maxSessionNumber + 1;
            
            this.setState({ sessionNumber: nextSessionNumber });
        } catch (error) {
            console.error('Error loading next session ID:', error);
            // Default to 1 if there's an error
            this.setState({ sessionNumber: 1 });
        }
    };

    handleSessionNumberChange = (event) => {
        const value = parseInt(event.target.value);
        if (!isNaN(value) && value > 0) {
            this.setState({ sessionNumber: value });
        }
    };

    startSession = () => {
        const { sessionNumber } = this.state;
        globalProps.history.push(`/admin/inventory/session/${sessionNumber}`);
    };

    getTieredPricingTooltip = (vendorPart) => {
        if (!vendorPart) return '';
        
        if (vendorPart.costType === 0 && vendorPart.tieredCostFormulas?.length > 0) {
            return vendorPart.tieredCostFormulas
                .sort((a, b) => a.quantity - b.quantity)
                .map(tier => `${tier.quantity}: $${Number(tier.price).toFixed(UNIT_COST_DECIMALS)} ea`)
                .join('\n');
        } else {
            return `${vendorPart.quantity}: $${Number(vendorPart.basePrice / vendorPart.quantity).toFixed(UNIT_COST_DECIMALS) || '0.00'} ea`;
        }
    };

    deselectAllParts = () => {
        this.setState({ 
            selectedParts: {},
            newLogParts: []
        }, () => {
            this.savePurchaseState();
        });
    };

    toggleShowNonInventoryItems = () => {
        this.setState(prevState => ({
            showNonInventoryItems: !prevState.showNonInventoryItems
        }), () => {
            this.saveFilterSettings();
        });
    };

    toggleShowLowInventoryOnly = () => {
        this.setState(prevState => ({
            showLowInventoryOnly: !prevState.showLowInventoryOnly
        }), () => {
            this.saveFilterSettings();
        });
    };

    toggleShowCriticalEffectiveInventoryOnly = () => {
        this.setState(prevState => ({
            showCriticalEffectiveInventoryOnly: !prevState.showCriticalEffectiveInventoryOnly
        }), () => {
            this.saveFilterSettings();
        });
    };

    evaluateCriticalEffectiveInventory = (partExpanded) => {
        const part = partExpanded.part;
        const { minQuantity, effectiveInventory } = this.getWorksheetOrderQuantityInputs(partExpanded);
        const inTransit = this.state.inTransitByPartId[part.id] || 0;
        const minReorderHighlight = this.getMinimumQuantityReorderHighlightState(partExpanded, effectiveInventory, minQuantity);
        const aggregatedSupersedesData = this.getAggregatedSupersedesSales(partExpanded);

        let combinedEffectiveInventory = effectiveInventory;
        if (aggregatedSupersedesData) {
            combinedEffectiveInventory = this.getCombinedEffectiveInventoryForWorksheet(partExpanded, effectiveInventory);
        }

        let combinedAverageSalesPerWeek = partExpanded.averageSalesPerWeek;
        if (aggregatedSupersedesData) {
            const combinedFourWeekSales = partExpanded.fourWeekAvgSales + aggregatedSupersedesData.fourWeekSales;
            const combinedTwentyFourWeekSales = partExpanded.twentyFourWeekAvgSales + aggregatedSupersedesData.twentyFourWeekSales;
            combinedAverageSalesPerWeek = (combinedFourWeekSales + combinedTwentyFourWeekSales) / 2;
        }

        return computeCriticalEffectiveInventoryWeeks({
            inTransit,
            reorderByMinimumQuantityBelowThreshold: !!(minReorderHighlight && minReorderHighlight.belowMinQty),
            combinedEffectiveInventory,
            effectiveInventory,
            minQuantity,
            averageSalesPerWeek: partExpanded.averageSalesPerWeek,
            combinedAverageSalesPerWeek,
            leadTimeInWeeks: part.leadTimeInWeeks,
            weeksToOrderBuffer: this.state.weeksToOrderBuffer,
            partExpanded,
            part,
            aggregatedSupersedesData,
            parts: this.state.parts,
            hasSupersedesChainWithSales: (p) => this.hasSupersedesChainWithSales(p),
            inTransitByPartId: this.state.inTransitByPartId,
        });
    };

    toggleShowOnlyPurchasing = () => {
        this.setState(prevState => ({
            showOnlyPurchasing: !prevState.showOnlyPurchasing
        }), () => {
            this.saveFilterSettings();
        });
    };

    // Helper function to check if any part in the supersedes chain has 24-week sales > 0
    hasSupersedesChainWithSales = (partExpanded) => {
        if (!partExpanded.part.supersedesId) return false;
        
        // Check if the direct superseded part has sales
        if (partExpanded.supersedesTwentyFourWeekAvgSales > 0) return true;
        
        // Recursively check the entire supersedes chain
        const checkSupersedesChain = (partId, visited = new Set()) => {
            if (visited.has(partId)) return false; // Prevent infinite loops
            visited.add(partId);
            
            const supersededPart = this.state.parts.find(x => x.part.id === partId);
            if (!supersededPart) return false;
            
            // Check if this part has 24-week sales
            if (supersededPart.twentyFourWeekAvgSales > 0) return true;
            
            // If this part supersedes another part, check that chain too
            if (supersededPart.part.supersedesId) {
                return checkSupersedesChain(supersededPart.part.supersedesId, visited);
            }
            
            return false;
        };
        
        return checkSupersedesChain(partExpanded.part.supersedesId);
    };

    // Helper function to get aggregated sales data from the entire supersedes chain
    getAggregatedSupersedesSales = (partExpanded) => {
        if (!partExpanded.part.supersedesId) return null;
        
        let aggregatedFourWeekSales = 0;
        let aggregatedTwentyFourWeekSales = 0;
        let aggregatedReceived = 0;
        let aggregatedSold = 0;
        let aggregatedUnpackaged = 0;
        
        // Recursively collect sales data from the entire supersedes chain
        const collectSupersedesData = (partId, visited = new Set()) => {
            if (visited.has(partId)) return; // Prevent infinite loops
            visited.add(partId);
            
            const supersededPart = this.state.parts.find(x => x.part.id === partId);
            if (!supersededPart) return;
            
            // Only include data from parts that have sales
            if (supersededPart.twentyFourWeekAvgSales > 0) {
                aggregatedFourWeekSales += supersededPart.fourWeekAvgSales || 0;
                aggregatedTwentyFourWeekSales += supersededPart.twentyFourWeekAvgSales || 0;
                aggregatedReceived += supersededPart.totalReceived || 0;
                aggregatedSold += supersededPart.totalSold || 0;
                aggregatedUnpackaged += supersededPart.totalUnpackaged || 0;
            }
            
            // If this part supersedes another part, collect from that chain too
            if (supersededPart.part.supersedesId) {
                collectSupersedesData(supersededPart.part.supersedesId, visited);
            }
        };
        
        collectSupersedesData(partExpanded.part.supersedesId);
        
        // Return aggregated data if any was found
        if (aggregatedTwentyFourWeekSales > 0) {
            return {
                fourWeekSales: aggregatedFourWeekSales,
                twentyFourWeekSales: aggregatedTwentyFourWeekSales,
                received: aggregatedReceived,
                sold: aggregatedSold,
                unpackaged: aggregatedUnpackaged
            };
        }
        
        return null;
    };

    /**
     * Sum Effective Inventory from parts this row supersedes (same formula as the Effective Inventory column,
     * including Strategy B packaging deficit — not raw unpackaged).
     */
    getSupersededEffectiveInventoryTotal = (partExpanded) => {
        if (!partExpanded?.part?.supersedesId) return 0;

        const collectSupersededInventory = (partId, visited = new Set()) => {
            if (visited.has(partId)) return 0;
            visited.add(partId);

            const supersededPart = this.state.parts.find(x => x.part.id === partId);
            if (!supersededPart) return 0;

            const { effectiveInventory: partEffectiveInventory } = this.getWorksheetOrderQuantityInputs(supersededPart);

            let totalInventory = partEffectiveInventory;
            if (supersededPart.part.supersedesId) {
                totalInventory += collectSupersededInventory(supersededPart.part.supersedesId, visited);
            }
            return totalInventory;
        };

        return collectSupersededInventory(partExpanded.part.supersedesId);
    };

    /** Combined on-hand position for the worksheet row when a supersede chain contributes inventory (matches table rendering). */
    getCombinedEffectiveInventoryForWorksheet = (partExpanded, effectiveInventory) => {
        const aggregatedSupersedesData = this.getAggregatedSupersedesSales(partExpanded);
        if (!aggregatedSupersedesData) return effectiveInventory;
        return effectiveInventory + this.getSupersededEffectiveInventoryTotal(partExpanded);
    };

    /**
     * When reorderByMinimumQuantity is set, weeks-to-order shows Above/Below Min Qty
     * instead of a numeric weeks value. Low-inventory filter uses Below Min Qty (red) only.
     * Below Min Qty when on-hand + on-order is strictly less than the min qty floor.
     * @returns {{ belowMinQty: boolean }|null}
     */
    getMinimumQuantityReorderHighlightState = (partExpanded, effectiveInventory, worksheetMinQuantity) => {
        const part = partExpanded.part;
        if (!part.reorderByMinimumQuantity) {
            return null;
        }
        const minQty = Number(part.minimumQuantity) || 0;
        const combinedEffective = this.getCombinedEffectiveInventoryForWorksheet(partExpanded, effectiveInventory);
        const onOrder = Number(partExpanded.onOrder) || 0;
        const position = combinedEffective + onOrder;
        return { belowMinQty: position < minQty };
    };

    getWeeksToOrderCellState = (partExpanded, effectiveInventory, minQuantity, weeksToOrder) => {
        const minReorderHighlight = this.getMinimumQuantityReorderHighlightState(partExpanded, effectiveInventory, minQuantity);
        if (minReorderHighlight) {
            const belowMinQty = minReorderHighlight.belowMinQty;
            return {
                display: belowMinQty ? 'Below Min Qty' : 'Above Min Qty',
                color: belowMinQty ? 'red' : 'white',
                isMinQtyReorder: true,
            };
        }

        let color = 'white';
        if (weeksToOrder < 1) color = 'red';
        else if (weeksToOrder < 3) color = 'orange';
        else if (weeksToOrder < 5) color = 'yellow';

        return {
            display: weeksToOrder,
            color,
            isMinQtyReorder: false,
        };
    };

    getSalesPerWeekForOrderCalculation = (partExpanded) => {
        let salesPerWeekForCalculation = partExpanded.averageSalesPerWeek;
        const aggregatedSupersedesData = this.getAggregatedSupersedesSales(partExpanded);
        if (aggregatedSupersedesData) {
            const combinedFourWeekSales = partExpanded.fourWeekAvgSales + aggregatedSupersedesData.fourWeekSales;
            const combinedTwentyFourWeekSales = partExpanded.twentyFourWeekAvgSales + aggregatedSupersedesData.twentyFourWeekSales;
            salesPerWeekForCalculation = (combinedFourWeekSales + combinedTwentyFourWeekSales) / 2;
        } else if (partExpanded.supersedesTwentyFourWeekAvgSales > 0) {
            const combinedFourWeekSales = partExpanded.fourWeekAvgSales + partExpanded.supersedesFourWeekAvgSales;
            const combinedTwentyFourWeekSales = partExpanded.twentyFourWeekAvgSales + partExpanded.supersedesTwentyFourWeekAvgSales;
            salesPerWeekForCalculation = (combinedFourWeekSales + combinedTwentyFourWeekSales) / 2;
        }
        return salesPerWeekForCalculation;
    };

    calculateSalesBasedOrderQuantity = (partExpanded, minQuantity, effectiveInventory, leadTimeInWeeks, salesPerWeekForCalculation) => {
        const combined = this.getCombinedEffectiveInventoryForWorksheet(partExpanded, effectiveInventory);
        const position = combined + partExpanded.onOrder;
        const leadTime = Number(leadTimeInWeeks) || 0;

        if (this.state.orderCalculationMethod === 'targetDate') {
            const today = new Date();
            const targetDateObj = dayjs.isDayjs(this.state.targetDate) ? this.state.targetDate : dayjs(this.state.targetDate);
            const targetDate = targetDateObj.toDate();
            const weeksToTarget = differenceInWeeks(targetDate, today, {roundingMethod: 'ceil'});
            const targetWeeksOfStock = weeksToTarget + leadTime;
            if (salesPerWeekForCalculation <= 0) {
                return Math.max(0, Math.ceil(targetWeeksOfStock * salesPerWeekForCalculation) + minQuantity - position);
            }
            const currentWeeksOfStock = (position - minQuantity) / salesPerWeekForCalculation;
            const weeksGap = targetWeeksOfStock - currentWeeksOfStock;
            if (weeksGap <= 0) return 0;
            return Math.ceil(weeksGap * salesPerWeekForCalculation);
        }

        const desiredWeeks = Number(this.state.desiredWeeksForOrder) || 0;
        const targetWeeksOfStock = desiredWeeks + leadTime;
        if (salesPerWeekForCalculation <= 0) {
            return Math.max(0, Math.ceil(targetWeeksOfStock * salesPerWeekForCalculation) + minQuantity - position);
        }
        const currentWeeksOfStock = (position - minQuantity) / salesPerWeekForCalculation;
        const weeksGap = targetWeeksOfStock - currentWeeksOfStock;
        if (weeksGap <= 0) return 0;
        return Math.ceil(weeksGap * salesPerWeekForCalculation);
    };

    calculateOrderQuantity = (partExpanded, minQuantity, effectiveInventory, leadTimeInWeeks) => {
        const salesPerWeekForCalculation = this.getSalesPerWeekForOrderCalculation(partExpanded);
        return this.calculateSalesBasedOrderQuantity(
            partExpanded,
            minQuantity,
            effectiveInventory,
            leadTimeInWeeks,
            salesPerWeekForCalculation
        );
    };

    /** Same inputs as the worksheet "Number to Order" column (min qty, packaging deficit string, effective inventory). */
    getWorksheetOrderQuantityInputs(partExpanded) {
        const part = partExpanded.part;
        let packagingDeficit = "0";
        let minQuantity = 0;
        if (part.inventoryStrategy === "B") {
            let sumOfPackagingDeficits = 0;
            this.state.subAssemblies.forEach((subAssembly) => {
                const assemblyPart = subAssembly.subAssembly.partsToSubAssemblies.find(x => x.partFk === part.id);
                if (assemblyPart && !assemblyPart.isImpliedPart) {
                    const averageSalesFourAndTwentyFour = (subAssembly.fourWeekSalesPerWeekWithRev + subAssembly.twentyFourWeekSalesPerWeekWithRev) / 2;
                    let targetAssembledOnHand = 10 * averageSalesFourAndTwentyFour < 2 ? 2 : 10 * averageSalesFourAndTwentyFour;
                    let minAssembledOnHand = 2 * averageSalesFourAndTwentyFour;
                    let avgAssembledOnHand = (minAssembledOnHand + targetAssembledOnHand) / 2;

                    sumOfPackagingDeficits += (subAssembly.totalAssembledOnHandWithRev * assemblyPart.quantity) - (Math.ceil(avgAssembledOnHand) * assemblyPart.quantity);
                    minQuantity += Math.ceil(minAssembledOnHand) * assemblyPart.quantity;
                }
            });
            this.state.assemblies.forEach((assembly) => {
                const assemblyPart = assembly.assembly.partsToAssemblies.find(x => x.partFk === part.id);
                if (assemblyPart && !assemblyPart.isImpliedPart) {
                    const averageSalesFourAndTwentyFour = (assembly.fourWeekSalesPerWeekWithRev + assembly.twentyFourWeekSalesPerWeekWithRev) / 2;
                    let targetAssembledOnHand = 10 * averageSalesFourAndTwentyFour < 2 ? 2 : 10 * averageSalesFourAndTwentyFour;
                    let minAssembledOnHand = 2 * averageSalesFourAndTwentyFour;
                    let avgAssembledOnHand = (minAssembledOnHand + targetAssembledOnHand) / 2;

                    sumOfPackagingDeficits += (assembly.totalAssembledOnHandWithRev * assemblyPart.quantity) - (Math.ceil(avgAssembledOnHand) * assemblyPart.quantity);
                    minQuantity += Math.ceil(minAssembledOnHand) * assemblyPart.quantity;
                }
            });
            packagingDeficit = sumOfPackagingDeficits < 0 ? sumOfPackagingDeficits.toFixed(0).toString() : "0";
        } else {
            this.state.subAssemblies.forEach((subAssembly) => {
                const assemblyPart = subAssembly.subAssembly.partsToSubAssemblies.find(x => x.partFk === part.id);
                if (assemblyPart && !assemblyPart.isImpliedPart) {
                    const averageSalesFourAndTwentyFour = (subAssembly.fourWeekSalesPerWeekWithRev + subAssembly.twentyFourWeekSalesPerWeekWithRev) / 2;
                    let minAssembledOnHand = 2 * averageSalesFourAndTwentyFour;
                    minQuantity += Math.ceil(minAssembledOnHand) * assemblyPart.quantity;
                }
            });
            this.state.assemblies.forEach((assembly) => {
                const assemblyPart = assembly.assembly.partsToAssemblies.find(x => x.partFk === part.id);
                if (assemblyPart && !assemblyPart.isImpliedPart) {
                    const averageSalesFourAndTwentyFour = (assembly.fourWeekSalesPerWeekWithRev + assembly.twentyFourWeekSalesPerWeekWithRev) / 2;
                    let minAssembledOnHand = 2 * averageSalesFourAndTwentyFour;
                    minQuantity += Math.ceil(minAssembledOnHand) * assemblyPart.quantity;
                }
            });
            packagingDeficit = "-";
        }

        if (part.reorderByMinimumQuantity) {
            minQuantity = Number(part.minimumQuantity) || 0;
        } else if (minQuantity < part.minimumQuantity) {
            minQuantity = part.minimumQuantity;
        }

        const effectiveInventory = part.inventoryStrategy === "A" ? partExpanded.totalReceived - partExpanded.totalSold : partExpanded.totalUnpackaged + Number.parseFloat(packagingDeficit);
        return { minQuantity, effectiveInventory, packagingDeficit };
    }

    /**
     * Quantity used for purchase when the row is not manually overridden: stays in sync when Desired Weeks / target date change.
     * Checkbox and selectedParts store a snapshot unless we refresh via syncSelectedPartsQuantitiesFromCalculation.
     */
    getResolvedOrderQuantityForPartId(partId) {
        if (this.state.overriddenQuantities[partId] !== undefined) {
            return this.state.overriddenQuantities[partId];
        }
        const partExpanded = this.state.parts.find(x => x.part.id === partId);
        if (!partExpanded) {
            return parseNumberInputValue(this.state.selectedParts[partId]) || 0;
        }
        const { minQuantity, effectiveInventory } = this.getWorksheetOrderQuantityInputs(partExpanded);
        return this.calculateOrderQuantity(partExpanded, minQuantity, effectiveInventory, partExpanded.part.leadTimeInWeeks);
    }

    syncSelectedPartsQuantitiesFromCalculation = () => {
        if (Object.keys(this.state.selectedParts).length === 0) {
            return;
        }
        const selectedParts = { ...this.state.selectedParts };
        let changed = false;
        for (const partId of Object.keys(selectedParts)) {
            const nextQty = this.getResolvedOrderQuantityForPartId(partId);
            if (selectedParts[partId] !== nextQty) {
                selectedParts[partId] = nextQty;
                changed = true;
            }
        }
        if (changed) {
            this.setState({ selectedParts }, () => this.savePurchaseState());
        }
    };

    handlePurchasePartsSearch = (event) => {
        this.setState({ purchasePartsSearchTerm: event.target.value });
    };

    getFilteredPurchaseParts = () => {
        let filteredParts = this.state.parts.filter(x => x.part.isActive === true);
        
        // Filter by isInventoryItem if the filter is not enabled
        if (!this.state.showNonInventoryItems) {
            filteredParts = filteredParts.filter(part => part.part.isInventoryItem !== false);
        }
        
        // Filter to show only parts with Purchase checkbox checked
        if (this.state.showOnlyPurchasing) {
            filteredParts = filteredParts.filter(part => this.state.selectedParts[part.part.id] !== undefined);
        }
        
        if (this.state.showCriticalEffectiveInventoryOnly) {
            filteredParts = filteredParts.filter(part =>
                this.evaluateCriticalEffectiveInventory(part).isCritical
            );
        }

        // Filter by low inventory if the filter is enabled
        if (this.state.showLowInventoryOnly) {
            filteredParts = filteredParts.filter(part => {
                const partExpanded = part;
                const partData = partExpanded.part;
                const { minQuantity, effectiveInventory } = this.getWorksheetOrderQuantityInputs(partExpanded);

                const minReorderHighlight = this.getMinimumQuantityReorderHighlightState(partExpanded, effectiveInventory, minQuantity);
                if (minReorderHighlight) {
                    return minReorderHighlight.belowMinQty;
                }

                const aggregatedSupersedesData = this.getAggregatedSupersedesSales(partExpanded);
                const combinedEffectiveInventory = this.getCombinedEffectiveInventoryForWorksheet(partExpanded, effectiveInventory);

                let combinedAverageSalesPerWeek = partExpanded.averageSalesPerWeek;
                if (aggregatedSupersedesData) {
                    const combinedFourWeekSales = partExpanded.fourWeekAvgSales + aggregatedSupersedesData.fourWeekSales;
                    const combinedTwentyFourWeekSales = partExpanded.twentyFourWeekAvgSales + aggregatedSupersedesData.twentyFourWeekSales;
                    combinedAverageSalesPerWeek = (combinedFourWeekSales + combinedTwentyFourWeekSales) / 2;
                }

                let weeksOfStock = "∞";
                if (partExpanded.fourWeekAvgSales > 0 || partExpanded.twentyFourWeekAvgSales > 0) {
                    weeksOfStock = Math.floor((effectiveInventory + partExpanded.onOrder - minQuantity) / partExpanded.averageSalesPerWeek);
                }

                let weeksToOrder = "∞";
                if (aggregatedSupersedesData) {
                    const combinedWeeksOfStock = Math.floor((combinedEffectiveInventory + partExpanded.onOrder - minQuantity) / combinedAverageSalesPerWeek);
                    weeksToOrder = Number.parseFloat(combinedWeeksOfStock) - partExpanded.part.leadTimeInWeeks - this.state.weeksToOrderBuffer;
                    if (partExpanded.totalSold === 0 && partData.supersedesId) {
                        const supersededPart = this.state.parts.find(x => x.part.id === partData.supersedesId);
                        if (supersededPart && (supersededPart.totalSold > 0 || this.hasSupersedesChainWithSales(supersededPart))) {
                            let supersededMinQuantity = 0;
                            const findSalesPartInChain = (partId) => {
                                const row = this.state.parts.find(x => x.part.id === partId);
                                if (!row) return null;
                                if (row.totalSold > 0) return row;
                                if (row.part.supersedesId) {
                                    return findSalesPartInChain(row.part.supersedesId);
                                }
                                return null;
                            };
                            const salesPart = findSalesPartInChain(partData.supersedesId);
                            if (salesPart) {
                                let salesPartMinQuantity = 0;
                                if (salesPart.part.inventoryStrategy === "B") {
                                    this.state.subAssemblies.forEach((subAssembly) => {
                                        const assemblyPart = subAssembly.subAssembly.partsToSubAssemblies.find(x => x.partFk === salesPart.part.id);
                                        if (assemblyPart && !assemblyPart.isImpliedPart) {
                                            const averageSalesFourAndTwentyFour = (subAssembly.fourWeekSalesPerWeekWithRev + subAssembly.twentyFourWeekSalesPerWeekWithRev) / 2;
                                            let minAssembledOnHand = 2 * averageSalesFourAndTwentyFour;
                                            salesPartMinQuantity += Math.ceil(minAssembledOnHand) * assemblyPart.quantity;
                                        }
                                    });
                                    this.state.assemblies.forEach((assembly) => {
                                        const assemblyPart = assembly.assembly.partsToAssemblies.find(x => x.partFk === salesPart.part.id);
                                        if (assemblyPart && !assemblyPart.isImpliedPart) {
                                            const averageSalesFourAndTwentyFour = (assembly.fourWeekSalesPerWeekWithRev + assembly.twentyFourWeekSalesPerWeekWithRev) / 2;
                                            let minAssembledOnHand = 2 * averageSalesFourAndTwentyFour;
                                            salesPartMinQuantity += Math.ceil(minAssembledOnHand) * assemblyPart.quantity;
                                        }
                                    });
                                } else {
                                    this.state.subAssemblies.forEach((subAssembly) => {
                                        const assemblyPart = subAssembly.subAssembly.partsToSubAssemblies.find(x => x.partFk === salesPart.part.id);
                                        if (assemblyPart && !assemblyPart.isImpliedPart) {
                                            const averageSalesFourAndTwentyFour = (subAssembly.fourWeekSalesPerWeekWithRev + subAssembly.twentyFourWeekSalesPerWeekWithRev) / 2;
                                            let minAssembledOnHand = 2 * averageSalesFourAndTwentyFour;
                                            salesPartMinQuantity += Math.ceil(minAssembledOnHand) * assemblyPart.quantity;
                                        }
                                    });
                                    this.state.assemblies.forEach((assembly) => {
                                        const assemblyPart = assembly.assembly.partsToAssemblies.find(x => x.partFk === salesPart.part.id);
                                        if (assemblyPart && !assemblyPart.isImpliedPart) {
                                            const averageSalesFourAndTwentyFour = (assembly.fourWeekSalesPerWeekWithRev + assembly.twentyFourWeekSalesPerWeekWithRev) / 2;
                                            let minAssembledOnHand = 2 * averageSalesFourAndTwentyFour;
                                            salesPartMinQuantity += Math.ceil(minAssembledOnHand) * assemblyPart.quantity;
                                        }
                                    });
                                }
                                supersededMinQuantity = salesPartMinQuantity;
                                if (supersededMinQuantity < salesPart.part.minimumQuantity) {
                                    supersededMinQuantity = salesPart.part.minimumQuantity;
                                }
                                const c4 = partExpanded.fourWeekAvgSales + aggregatedSupersedesData.fourWeekSales;
                                const c24 = partExpanded.twentyFourWeekAvgSales + aggregatedSupersedesData.twentyFourWeekSales;
                                const avgSuperseded = (c4 + c24) / 2;
                                const supersededWeeksOfStock = Math.floor((combinedEffectiveInventory + supersededPart.onOrder + partExpanded.onOrder - supersededMinQuantity) / avgSuperseded);
                                if (supersededWeeksOfStock !== "∞") {
                                    weeksToOrder = Math.ceil(Number.parseFloat(supersededWeeksOfStock) - partExpanded.part.leadTimeInWeeks - this.state.weeksToOrderBuffer);
                                }
                            }
                        }
                    }
                } else if (weeksOfStock !== "∞") {
                    weeksToOrder = Math.ceil(Number.parseFloat(weeksOfStock) - partExpanded.part.leadTimeInWeeks - this.state.weeksToOrderBuffer);
                }

                // Show only parts with 4 or fewer weeks to order (including yellow, orange, and red items)
                return weeksToOrder !== "∞" && weeksToOrder <= 4;
            });
        }
        
        if (!this.state.searchTerm) return filteredParts;
        
        const searchTerms = this.state.searchTerm.split(' ').filter(term => term.trim() !== '');
        if (searchTerms.length === 0) return filteredParts;
        
        return filteredParts.filter(part => {
            // All search terms must match at least one field
            return searchTerms.every(term => {
                const searchTerm = term.toLowerCase();
                const vendorName = this.getVendorName(part.part.selectedVendorId);
                return (part.part.partId && part.part.partId.toLowerCase().includes(searchTerm)) ||
                       (part.part.description && part.part.description.toLowerCase().includes(searchTerm)) ||
                       (part.part.partType && part.part.partType.toLowerCase().includes(searchTerm)) ||
                       (part.part.manufacturerFor && part.part.manufacturerFor.toLowerCase().includes(searchTerm)) ||
                       (part.part.tertiaryType && part.part.tertiaryType.toLowerCase().includes(searchTerm)) ||
                       (vendorName && vendorName.toLowerCase().includes(searchTerm));
            });
        });
    };

    getVendorName = (selectedVendorId) => {
        if (!selectedVendorId || !this.state.vendors || this.state.vendors.length === 0) {
            return '';
        }
        const vendor = this.state.vendors.find(x => x.id === selectedVendorId);
        return vendor ? (vendor.name || '') : '';
    };

    handleVendorChange = (event, index) => {
        const newLogParts = [...this.state.newLogParts];
        const row = newLogParts[index];
        const vendorId = event.target.value;
        const vendor = this.state.vendors.find(x => x.id === vendorId);
        const vendorPart = row.vendorParts?.find(vp => vp.vendorId === vendorId);

        if (vendorPart) {
            // Keep user's quantity; only update price/total from new vendor's pricing
            const quantity = parseNumberInputValue(row.partQuantity) || 1;
            let newPrice = 0;

            if (vendorPart.costType === 0) { // Tiered pricing
                const sortedTiers = [...(vendorPart.tieredCostFormulas || [])].sort((a, b) => a.quantity - b.quantity);
                const tier = quantity < sortedTiers[0]?.quantity
                    ? sortedTiers[0]
                    : [...sortedTiers].reverse().find(t => quantity >= t.quantity) || sortedTiers[sortedTiers.length - 1];
                if (tier) {
                    newPrice = Number(tier.price);
                }
            } else { // Fixed pricing
                newPrice = Number(vendorPart.basePrice / vendorPart.quantity) || 0;
            }

            row.vendor = vendor.name;
            row.vendorId = vendorId;
            row.price = normalizeUnitCost(newPrice);
            // Do not overwrite row.partQuantity - keep the user's entered quantity
            row.total = calculateLineTotal(newPrice, quantity);
            row.isOverridden = true;

            this.setState({ newLogParts }, () => {
                this.savePurchaseState();
            });
        }
    };

    handleFamilyQuantityChange = (event, rowIndex) => {
        const newQuantity = event.target.value;
        const familyId = this.state.newLogParts[rowIndex].familyId;

        const updatedLogParts = this.state.newLogParts.map((row, index) => {
            if (index === rowIndex) {
                return { ...row, familyQuantity: newQuantity };
            }
            if (row.familyId === familyId && !row.isFamilyRow) {
                const part = this.state.parts.find(x => x.part.id === row.partId);
                if (!part) return row;
                
                // Get the PartToFamily relationship for this part and family
                const partToFamily = part.part.partToFamilies.find(ptf => ptf.familyId === familyId);
                const purchaseQuantity = parseInt(partToFamily?.purchaseQuantity) || 1;
                const partQuantity = purchaseQuantity * parseNumberInputValue(newQuantity);
                
                // Find the vendor part to check for tiered pricing
                const vendorPart = row.vendorParts?.find(vp => vp.vendorId === row.vendorId);
                let newPrice = normalizeUnitCost(row.price);
                
                if (vendorPart && vendorPart.costType === 0 && !row.isOverridden) { // Tiered pricing
                    // Sort tiers by quantity ascending
                    const sortedTiers = [...vendorPart.tieredCostFormulas].sort((a, b) => a.quantity - b.quantity);
                    // Find the highest tier less than or equal to the quantity
                    const tier = [...sortedTiers].reverse().find(t => partQuantity >= t.quantity) || sortedTiers[0];
                    newPrice = normalizeUnitCost(tier.price);
                }
                
                return {
                    ...row,
                    partQuantity: partQuantity,
                    price: normalizeUnitCost(newPrice),
                    total: calculateLineTotal(newPrice, partQuantity),
                    isOverridden: false // Reset override flag when family quantity changes
                };
            }
            return row;
        });

        this.setState({ newLogParts: updatedLogParts }, () => {
            this.savePurchaseState();
        });
    };

    handlePartQuantityChange = (event, index) => {
        const quantity = event.target.value;
        const newLogParts = [...this.state.newLogParts];
        const changingPart = newLogParts[index];
        
        // Check if changingPart exists
        if (!changingPart) {
            console.error('changingPart not found at index:', index);
            return;
        }
        
        // Ensure price is always a number
        let newPrice = changingPart.price || 0;
        
        // Find the vendor part to check for tiered pricing
        const vendorPart = changingPart.vendorParts?.find(vp => vp.vendorId === changingPart.vendorId);
        
        if (vendorPart && vendorPart.costType === 0 && !changingPart.isOverridden && vendorPart.tieredCostFormulas && vendorPart.tieredCostFormulas.length > 0) { // Tiered pricing
            // Sort tiers by quantity ascending
            const sortedTiers = [...vendorPart.tieredCostFormulas].sort((a, b) => a.quantity - b.quantity);
            // Find the highest tier less than or equal to the quantity
            const tier = [...sortedTiers].reverse().find(t => quantity >= t.quantity) || sortedTiers[0];
            if (tier && tier.price !== undefined) {
                newPrice = normalizeUnitCost(tier.price);
            }
        }
        
        changingPart.partQuantity = quantity;
        changingPart.price = normalizeUnitCost(newPrice);
        changingPart.total = calculateLineTotal(changingPart.price, quantity);
        
        this.setState({ newLogParts }, () => {
            this.savePurchaseState();
        });
    };

    handlePartPriceChange = (event, index) => {
        const newLogParts = [...this.state.newLogParts];
        const row = newLogParts[index];
        
        // Check if row exists
        if (!row) {
            console.error('Row not found at index:', index);
            return;
        }
        
        const newPrice = event.target.value;
        const quantity = row.partQuantity || 0;
        
        row.price = normalizeUnitCost(newPrice);
        row.total = calculateLineTotal(row.price, quantity);
        row.isOverridden = true;

        this.setState({ newLogParts }, () => {
            this.savePurchaseState();
        });
    };

    removeLine = (index) => {
        const newLogParts = [...this.state.newLogParts];
        newLogParts.splice(index, 1);
        this.setState({ newLogParts }, () => {
            this.savePurchaseState();
        });
    };

    handleQuantityKeyDown = (event, currentIndex) => {
        if (event.key === 'Tab' && !event.shiftKey) {
            // If this is the last row and we're tabbing forward from the quantity field, create new line
            if (currentIndex === this.state.newLogParts.length - 1) {
                event.preventDefault();
                this.addNewLine();
                // Focus on the new row's part number field
                setTimeout(() => {
                    const nextRowIndex = this.state.newLogParts.length - 1;
                    const nextInput = document.querySelector(`input[data-row-index="${nextRowIndex}"][data-field-type="part-number"]`);
                    if (nextInput) {
                        nextInput.focus();
                    }
                }, 100);
            }
        }
    };

    openPurchaseDrawer = async () => {
        const partService = ServiceLocator.Instance.getPartService();
        const newLogParts = [];
        
        // Group selected parts by family to handle family logic
        const familyGroups = new Map();
        const individualParts = [];
        console.log('Selected parts:', this.state.selectedParts);
        
        for (const partId of Object.keys(this.state.selectedParts)) {
            const partExpanded = this.state.parts.find(x => x.part.id === partId);
            if (!partExpanded) continue;
            const quantity = this.getResolvedOrderQuantityForPartId(partId);

            // Check if this part belongs to a family
            const partToFamilies = partExpanded.part.partToFamilies || [];
            
            // Only select the family if the part belongs to exactly one family and is not an implied part
            if (partToFamilies.length === 1) {
                const partToFamily = partToFamilies[0];
                
                // Skip implied parts - treat as individual part
                if (partToFamily.isImpliedPart) {
                    individualParts.push({
                        partId: partId,
                        partExpanded: partExpanded,
                        quantity: quantity
                    });
                    continue;
                }
                
                // Part belongs to exactly one family and is not implied - add to family group
                const familyId = partToFamily.familyId;
                if (!familyGroups.has(familyId)) {
                    familyGroups.set(familyId, {
                        familyId: familyId,
                        parts: [],
                        maxPurchaseQuantity: 0
                    });
                }
                const familyGroup = familyGroups.get(familyId);
                familyGroup.parts.push({
                    partId: partId,
                    partExpanded: partExpanded,
                    quantity: quantity,
                    purchaseQuantity: partToFamily.purchaseQuantity || 1
                });
                familyGroup.maxPurchaseQuantity = Math.max(familyGroup.maxPurchaseQuantity, partToFamily.purchaseQuantity || 1);
            } else {
                // If part belongs to multiple families or no families, select the part directly
                individualParts.push({
                    partId: partId,
                    partExpanded: partExpanded,
                    quantity: quantity
                });
            }
        }
        
        // Parts that belong to multiple families (or zero) go to `individualParts`. If another
        // selected part triggers a family expansion that includes the same part, we would add it
        // twice (once as a family line, once as individual). Collect every part id that will be
        // emitted by family expansion so we skip those from individualParts.
        const partIdsExpandedByFamily = new Set();
        for (const familyId of familyGroups.keys()) {
            this.state.parts.forEach((partExpanded) => {
                const ptf = partExpanded.part.partToFamilies?.find((x) => x.familyId === familyId);
                if (ptf && !ptf.isImpliedPart) {
                    partIdsExpandedByFamily.add(partExpanded.part.id);
                }
            });
        }
        const individualPartsForPurchase = individualParts.filter(
            (p) => !partIdsExpandedByFamily.has(p.partId)
        );
        
        console.log('Family groups created:', familyGroups);
        console.log('Individual parts:', individualParts);
        console.log('Individual parts after excluding family-expanded ids:', individualPartsForPurchase);
        
        // Process family groups - add family as a single line item and all parts within the family
        for (const [familyId, familyGroup] of familyGroups) {
            console.log(`Processing family ${familyId}:`, familyGroup);
            const family = this.state.partFamilies.find(f => f.id === familyId);
            console.log('Found family:', family);
            if (!family) continue;
            
            // Get all parts that belong to this family (not just selected ones)
            const allFamilyParts = this.state.parts.filter(partExpanded => 
                partExpanded.part.partToFamilies?.some(ptf => ptf.familyId === familyId)
            );
            console.log(`All family parts for ${familyId}:`, allFamilyParts.map(p => p.part.partId));
            
            // Get the first part's vendor information for the family
            const firstPart = familyGroup.parts[0];
            const selectedVendorId = firstPart.partExpanded.part.selectedVendorId;
            const vendorPart = firstPart.partExpanded.part.vendorParts.find(x => x.vendorId === selectedVendorId) || firstPart.partExpanded.part.vendorParts[0];
            const vendor = vendorPart ? this.state.vendors.find(x => x.id === vendorPart.vendorId) : null;
            
            // Calculate family quantity based on selected parts' requirements
            let maxFamilyQuantity = 0;
            for (const selectedPart of familyGroup.parts) {
                const requiredQuantity = selectedPart.quantity; // This is the "number to order" from the UI
                const purchaseQuantity = selectedPart.purchaseQuantity; // This is the purchaseQuantity from PartToFamily
                
                // Calculate how many of the family we need to order to fulfill this part's requirement
                // If purchaseQuantity is 1, we need 'requiredQuantity' of the family
                // If purchaseQuantity is 2, we need Math.ceil(requiredQuantity / 2) of the family
                const familyQuantityForThisPart = Math.ceil(requiredQuantity / purchaseQuantity);
                maxFamilyQuantity = Math.max(maxFamilyQuantity, familyQuantityForThisPart);
            }
            
            const familyQuantity = maxFamilyQuantity;

            let initialPrice = 0;
            if (vendorPart) {
                if (vendorPart.costType === 0 && vendorPart.tieredCostFormulas?.length) {
                    const tierPrice = getTieredUnitPriceForQuantity(vendorPart, familyQuantity);
                    initialPrice = tierPrice ?? 0;
                } else {
                    initialPrice = normalizeUnitCost(vendorPart.basePrice / vendorPart.quantity);
                }
            }
            
            // Add the family row
            newLogParts.push({
                id: uuid(),
                partId: familyId,
                description: `${family.partFamilyId || family.description || `Family ${familyId}`} (Family)`,
                vendorParts: firstPart.partExpanded.part.vendorParts,
                vendorId: vendorPart?.vendorId,
                vendor: vendor?.name,
                familyQuantity: familyQuantity,
                price: initialPrice,
                total: calculateLineTotal(initialPrice, familyQuantity),
                isFamilyRow: true,
                isFamilyPart: false,
                familyId: familyId,
                familyParts: familyGroup.parts,
                selectedOption: {
                    title: `${family.partFamilyId || family.description || `Family ${familyId}`} (Family)`,
                    value: familyId,
                    isFamily: true,
                    family: family
                }
            });

            console.log(`Processing ${allFamilyParts.length} family parts`);
            const familyMemberPartIdsAdded = new Set();
            allFamilyParts.forEach((partExpanded) => {
                console.log(`Processing family part: ${partExpanded.part.partId}`);
                const partToFamily = partExpanded.part.partToFamilies.find(ptf => ptf.familyId === familyId);
                
                // Skip implied parts when adding families to inventory
                if (partToFamily && partToFamily.isImpliedPart) {
                    console.log(`Skipping implied part: ${partExpanded.part.partId}`);
                    return;
                }
                if (familyMemberPartIdsAdded.has(partExpanded.part.id)) {
                    console.log(`Skipping duplicate family member row: ${partExpanded.part.partId}`);
                    return;
                }
                familyMemberPartIdsAdded.add(partExpanded.part.id);
                const purchaseQuantity = partToFamily?.purchaseQuantity || 1;
                const selectedQuantityForPart = this.state.selectedParts[partExpanded.part.id];
                const partQuantity = selectedQuantityForPart !== undefined
                    ? this.getResolvedOrderQuantityForPartId(partExpanded.part.id)
                    : purchaseQuantity * familyQuantity;
                
                // Get vendor information for this specific part
                const partVendorPart = partExpanded.part.vendorParts.find(x => x.vendorId === partExpanded.part.selectedVendorId) || partExpanded.part.vendorParts[0];
                const partVendor = partVendorPart ? this.state.vendors.find(x => x.id === partVendorPart.vendorId) : null;
                
                // Calculate price for this part (tier by line quantity, not catalog "selected" tier)
                let partPrice = 0;
                if (partVendorPart) {
                    if (partVendorPart.costType === 0 && partVendorPart.tieredCostFormulas?.length) {
                        const tierPrice = getTieredUnitPriceForQuantity(partVendorPart, partQuantity);
                        partPrice = tierPrice ?? 0;
                    } else {
                        partPrice = normalizeUnitCost(partVendorPart.basePrice / partVendorPart.quantity);
                    }
                }
                
                const newPart = {
                    id: uuid(),
                    familyId: familyId,
                    familyQuantity: familyQuantity,
                    partId: partExpanded.part.id,
                    partQuantity: partQuantity,
                    description: partExpanded.part.description,
                    vendor: partVendor?.name,
                    vendorId: partVendorPart?.vendorId,
                    price: partPrice,
                    total: calculateLineTotal(partPrice, partQuantity),
                    isFamilyRow: false,
                    isOverridden: false,
                    isFamilyPart: true,
                    vendorParts: partExpanded.part.vendorParts,
                    selectedOption: {
                        title: `${partExpanded.part.partId} rev ${partExpanded.part.revision}`,
                        value: partExpanded.part.id,
                        isFamily: false,
                        part: partExpanded
                    }
                };
                console.log(`Adding family part to newLogParts:`, newPart);
                newLogParts.push(newPart);
            });
        }
        
        // Process individual parts (not in families, and not already expanded above)
        for (const partData of individualPartsForPurchase) {
            const partExpanded = partData.partExpanded;

            // Get the selected vendor or default to first vendor
            const selectedVendorId = partExpanded.part.selectedVendorId;
            const vendorPart = partExpanded.part.vendorParts.find(x => x.vendorId === selectedVendorId) || partExpanded.part.vendorParts[0];
            const vendor = vendorPart ? this.state.vendors.find(x => x.id === vendorPart.vendorId) : null;
            
            // Calculate initial price from order quantity (tier by quantity, not catalog "selected" tier)
            let initialPrice = 0;
            let initialQuantity = parseNumberInputValue(partData.quantity) || 0;
            if (vendorPart) {
                if (vendorPart.costType === 0 && vendorPart.tieredCostFormulas?.length) {
                    const tierPrice = getTieredUnitPriceForQuantity(vendorPart, initialQuantity);
                    initialPrice = tierPrice ?? 0;
                } else {
                    // For fixed pricing, use basePrice / quantity for per-unit cost
                    initialPrice = normalizeUnitCost(vendorPart.basePrice / vendorPart.quantity);
                }
            }

            newLogParts.push({
                id: uuid(),
                partId: partData.partId,
                description: partExpanded.part.description,
                vendorParts: partExpanded.part.vendorParts,
                vendorId: vendorPart?.vendorId,
                vendor: vendor?.name,
                partQuantity: initialQuantity,
                price: initialPrice,
                total: calculateLineTotal(initialPrice, initialQuantity),
                isFamilyRow: false,
                isFamilyPart: false,
                selectedOption: {
                    title: `${partExpanded.part.partId} rev ${partExpanded.part.revision}`,
                    value: partExpanded.part.id,
                    isFamily: false,
                    part: partExpanded.part
                },
                isModifying: false
            });
        }
        
        // Check if we have saved purchase state and merge it with new parts
        const savedPurchaseState = localStorage.getItem('inventory_purchase_state');
        let partsToUse = newLogParts;
        
        if (savedPurchaseState) {
            try {
                const parsedState = JSON.parse(savedPurchaseState);
                if (parsedState.newLogParts && parsedState.newLogParts.length > 0) {
                    // Merge saved parts with new parts, avoiding duplicates
                    const existingPartIds = new Set(newLogParts.map(part => part.partId));
                    const savedPartsToAdd = parsedState.newLogParts.filter(savedPart => 
                        !existingPartIds.has(savedPart.partId)
                    );
                    partsToUse = [...newLogParts, ...savedPartsToAdd];
                }
            } catch (error) {
                console.warn('Failed to parse saved purchase state:', error);
            }
        }
        
        // Filter parts to only include those that are still checked (exist in selectedParts)
        // This removes any parts that were previously checked but then unchecked
        // For family parts, check if any part in the family is still selected
        console.log('Before filtering, partsToUse length:', partsToUse.length);
        partsToUse = partsToUse.filter(part => {
            if (part.isFamilyRow) {
                // For family rows, check if any part in the family is still selected
                const shouldKeep = part.familyParts?.some(familyPart => this.state.selectedParts[familyPart.partId]);
                console.log(`Family row ${part.partId} should keep:`, shouldKeep);
                return shouldKeep;
            } else if (part.isFamilyPart) {
                // For individual parts within families, check if ANY part in the family is selected
                // We need to find the family and check if any part in that family is selected
                const familyId = part.familyId;
                const familyParts = this.state.parts.filter(p => 
                    p.part.partToFamilies?.some(ptf => ptf.familyId === familyId)
                );
                const shouldKeep = familyParts.some(familyPart => this.state.selectedParts[familyPart.part.id]);
                console.log(`Family part ${part.partId} should keep:`, shouldKeep);
                return shouldKeep;
            } else {
                // For individual parts, check if the part is still selected
                const shouldKeep = this.state.selectedParts[part.partId];
                console.log(`Individual part ${part.partId} should keep:`, shouldKeep);
                return shouldKeep;
            }
        });
        console.log('After filtering, partsToUse length:', partsToUse.length);
        
        // Order lines like the main inventory table (state.parts / loadParts order), not by part number.
        const partIdToOrderIndex = new Map();
        this.state.parts.forEach((pe, i) => {
            partIdToOrderIndex.set(pe.part.id, i);
        });
        const getOrderIndex = (partId) => partIdToOrderIndex.get(partId) ?? Number.MAX_SAFE_INTEGER;

        const familyGroupsMap = new Map();
        const individualPartsForSorting = [];

        for (const row of partsToUse) {
            if (row.isFamilyRow) {
                if (!familyGroupsMap.has(row.familyId)) {
                    familyGroupsMap.set(row.familyId, { familyRow: row, familyParts: [] });
                }
            } else if (row.isFamilyPart) {
                if (!familyGroupsMap.has(row.familyId)) {
                    familyGroupsMap.set(row.familyId, { familyRow: null, familyParts: [] });
                }
                familyGroupsMap.get(row.familyId).familyParts.push(row);
            } else {
                individualPartsForSorting.push(row);
            }
        }

        for (const group of familyGroupsMap.values()) {
            group.familyParts.sort((a, b) => getOrderIndex(a.partId) - getOrderIndex(b.partId));
        }

        const minIndexForFamilyGroup = (group) => {
            const indices = [];
            if (group.familyRow?.familyParts) {
                group.familyRow.familyParts.forEach((fp) => indices.push(getOrderIndex(fp.partId)));
            }
            group.familyParts.forEach((fp) => indices.push(getOrderIndex(fp.partId)));
            return indices.length ? Math.min(...indices) : Number.MAX_SAFE_INTEGER;
        };

        const units = [];
        for (const [, group] of familyGroupsMap) {
            units.push({ type: 'family', minOrder: minIndexForFamilyGroup(group), group });
        }
        individualPartsForSorting.forEach((row) => {
            units.push({ type: 'individual', minOrder: getOrderIndex(row.partId), row });
        });
        units.sort((a, b) => a.minOrder - b.minOrder);

        const sortedParts = [];
        for (const u of units) {
            if (u.type === 'family') {
                const g = u.group;
                if (g.familyRow) {
                    sortedParts.push(g.familyRow);
                }
                sortedParts.push(...g.familyParts);
            } else {
                sortedParts.push(u.row);
            }
        }
        
        this.setState({
            purchaseDrawerOpen: true,
            newLogParts: sortedParts,
            newPurchaseOrderDate: dayjs(new Date().toUTCString())
        });
        this.savePurchaseState();
    };

    closePurchaseDrawer = () => {
        this.setState({ 
            purchaseDrawerOpen: false,
            newVendorOrderNumber: ''
        });
        // Don't clear the purchase state when just closing the drawer
        // Only clear it when purchases are actually made
    };

    updatePurchaseDrawerQuantity = (partId, quantity) => {
        const purchaseDrawerParts = this.state.purchaseDrawerParts.map(part => {
            if (part.partId === partId) {
                const partExpanded = this.state.parts.find(x => x.part.id === partId);
                const unitCost = partExpanded ? partExpanded.cost : 0.00;
                const newQuantity = parseInt(quantity) || 0;
                const pricePaid = calculateLineTotal(unitCost, newQuantity).toFixed(2);
                return { 
                    ...part, 
                    quantity: newQuantity,
                    pricePaid: parseFloat(pricePaid)
                };
            }
            return part;
        });
        this.setState({ purchaseDrawerParts }, () => {
            this.savePurchaseState();
        });
    };

    removeFromPurchaseDrawer = (partId) => {
        const purchaseDrawerParts = this.state.purchaseDrawerParts.filter(part => part.partId !== partId);
        const selectedParts = { ...this.state.selectedParts };
        delete selectedParts[partId];
        this.setState({ purchaseDrawerParts, selectedParts }, () => {
            this.savePurchaseState();
        });
    };

    completePurchase = () => {
        if (this.state.purchaseDrawerParts.length === 0) {
            window.$alertWarning("No parts selected for purchase");
            return;
        }

        // Group parts by vendor
        const vendorGroups = {};
        this.state.purchaseDrawerParts.forEach(part => {
            if (!vendorGroups[part.companyName]) {
                vendorGroups[part.companyName] = [];
            }
            vendorGroups[part.companyName].push(part);
        });

        // Create a purchase order for each vendor
        const promises = Object.entries(vendorGroups).map(([vendor, parts]) => {
            const orderId = uuid();
            const newLogParts = parts.map(part => ({
                id: uuid(),
                companyName: vendor,
                quantity: part.quantity,
                quantityReceived: part.isReceived ? part.quantityReceived : 0,
                partId: part.partId,
                isPaid: part.isPaid,
                pricePaid: part.isPaid ? part.pricePaid : 0.00,
                orderDate: this.state.newPurchaseLogOrderDate,
                orderId: orderId,
                receivedDate: part.isReceived ? part.receivedDate : null
            }));

            const purchaseOrder = {
                id: orderId,
                placedOn: this.state.newPurchaseLogOrderDate,
                pricePaid: normalizeMoney(parts.reduce((sum, part) => sum + (part.isPaid ? part.pricePaid : 0), 0)),
                invoices: [],
                packingSlips: [],
                purchasedParts: newLogParts
            };

            const partService = ServiceLocator.Instance.getPartService();
            return partService.createPurchaseOrder(purchaseOrder);
        });

        Promise.all(promises).then((purchaseOrders) => {
            this.setState({selectedPurchaseOrderId: purchaseOrders[0].id});
            Promise.all([this.saveInvoiceFiles(), this.savePackingSlipFiles()]).then(() => {
                window.$alertSuccess("Purchase orders created successfully");
                this.setState({
                    purchaseDrawerOpen: false,
                    selectedParts: {},
                    overriddenQuantities: {},
                    purchaseDrawerParts: [],
                    newLogParts: [],
                    invoiceFiles: [],
                    packingSlipFiles: [],
                    newVendorOrderNumber: ''
                });
                this.clearPurchaseState();
                this.loadData();
            });
        });
    };

    saveInvoiceFiles = () => {
        // Note: Invoice attachment is now handled at the line-item level in the Purchases interface
        // This inventory interface no longer supports direct invoice upload
        return Promise.resolve();
    };

    savePackingSlipFiles = () => {
        const self = this;
        if (this.state.packingSlipFiles.length > 0) {
            self.setState({savingPurchaseOrder: true});
            let formData = new FormData();
            this.state.packingSlipFiles.forEach((file) => {
                formData.append('files[' + this.state.packingSlipFiles.indexOf(file) + ']', file);
            });
            const partService = ServiceLocator.Instance.getPartService();
            return partService.createPurchaseOrderPackingSlip(this.state.selectedPurchaseOrderId, formData).then((newPackingSlip) => {
                window.$alertSuccess("Packing slip(s) uploaded.");
                self.setState({savingPurchaseOrder: false});
                return newPackingSlip;
            }).catch(function (error) {
                window.$alertError("Something went wrong saving your packing slip.");
                console.log(error);
                self.setState({savingPurchaseOrder: false});
            });
        } else return Promise.resolve();
    };

    addNewLine = () => {
        const newLine = {
            id: uuid(),
            isFamilyRow: true,
            selectedOption: null,
            familyQuantity: 1,
            description: '',
            isFamilyPart: false,
            price: 0,
            partQuantity: 1,
            total: 0
        };
        this.setState(prevState => ({
            newLogParts: [...prevState.newLogParts, newLine]
        }));
    };

    submitPurchaseOrder = () => {
        const self = this;
        self.setState({savingPurchaseLog: true});

        // Group parts by vendor
        const vendorGroups = {};
        this.state.newLogParts.filter(x => !x.isFamilyRow).forEach(part => {
            if (!vendorGroups[part.vendor]) {
                vendorGroups[part.vendor] = [];
            }
            vendorGroups[part.vendor].push(part);
        });

        // Create a purchase order for each vendor
        const promises = Object.entries(vendorGroups).map(([vendor, parts]) => {
            const payload = {
                id: uuid(),
                placedOn: this.state.newPurchaseOrderDate,
                vendorOrderNumber: this.state.newVendorOrderNumber,
                pricePaid: normalizeMoney(parts.reduce((sum, part) => sum + (part.total || 0), 0)),
                invoices: [],
                packingSlips: [],
                userId: AuthenticationService.getInstance().getUserId(),
                purchasedParts: parts.map(part => {
                    const basePart = {
                        id: uuid(),
                        companyName: vendor,
                        quantityReceived: 0,
                        isPaid: false,
                        isReceived: false,
                        orderDate: this.state.newPurchaseOrderDate,
                        receivedDate: null,
                        pricePaid: normalizeMoney(part.total),
                        userId: AuthenticationService.getInstance().getUserId()
                    };

                    // If this part has a family and no quantity override, use the family ID
                    if (part.family && !part.quantity) {
                        return {
                            ...basePart,
                            partFamilyId: part.family.id,
                            quantity: part.family.quantity
                        };
                    }
                    // Otherwise use the individual part ID and quantity
                    return {
                        ...basePart,
                        partId: part.partId,
                        quantity: part.partQuantity
                    };
                })
            };
            const partService = ServiceLocator.Instance.getPartService();
            return partService.createPurchaseOrder(payload);
        });

        Promise.all(promises).then(() => {
            // Create copy table data grouped by vendor
            const copyTablesByVendor = {};
            Object.entries(vendorGroups).forEach(([vendor, parts]) => {
                copyTablesByVendor[vendor] = parts.map(part => {
                    const partExpanded = self.state.parts.find(x => x.part.id === part.partId);
                    return {
                        partNumber: partExpanded?.part.partId || 'Unknown',
                        revision: partExpanded?.part.revision || '',
                        quantity: part.partQuantity
                    };
                });
            });
            
            window.$alertSuccess("Purchase orders created");
            self.clearPurchaseState(); // Clear localStorage purchase checkboxes
            self.setState({
                purchaseDrawerOpen: false, 
                savingPurchaseLog: false,
                showCopyTable: true,
                copyTablesByVendor,
                selectedParts: {}, // Clear selected parts from component state
                overriddenQuantities: {}, // Clear overridden quantities
                newLogParts: [] // Clear new log parts
            });
            self.loadData();
        });
    };

    handlePartDisplayClick = (rowIndex) => {
        // Set isModifying to true to show the autocomplete
        const updatedRows = [...this.state.newLogParts];
        updatedRows[rowIndex].isModifying = true;
        this.setState({ newLogParts: updatedRows });
    };

    handleFamilyChange = (event, newValue, index) => {
        if (!newValue) return;

        const newLogParts = [...this.state.newLogParts];
        
        if (newValue.isFamily) {
            const family = this.state.partFamilies.find(x => x.id === newValue.value);
            if (family) {
                // Update the family row
                newLogParts[index] = {
                    ...newLogParts[index],
                    familyId: family.id,
                    familyQuantity: 1,
                    isFamilyRow: true,
                    description: family.description,
                    partId: null,
                    partQuantity: null,
                    vendor: '',
                    price: 0,
                    total: 0,
                    selectedOption: {
                        ...newValue,
                        family: family
                    }
                };

                // Find all parts in this family using partToFamilies
                const familyParts = this.state.parts.filter(part => 
                    part.part.partToFamilies && 
                    part.part.partToFamilies.some(ptf => ptf.familyId === family.id)
                );
                
                // Remove any existing part rows for this family
                const filteredLogParts = newLogParts.filter((row, i) => 
                    i === index || row.familyId !== family.id
                );
                
                // Filter out implied parts and add part rows after the family row
                const filteredFamilyParts = familyParts.filter(part => {
                    const partToFamily = part.part.partToFamilies.find(ptf => ptf.familyId === family.id);
                    return !partToFamily || !partToFamily.isImpliedPart;
                });
                
                filteredFamilyParts.forEach((part, i) => {
                    const partToFamily = part.part.partToFamilies.find(ptf => ptf.familyId === family.id);
                    const vendorPart = part.part.vendorParts.find(x => x.vendorId === part.part.selectedVendorId) || part.part.vendorParts[0];
                    const vendorName = vendorPart ? this.state.vendors.find(x => x.id === vendorPart.vendorId)?.name : '';
                    let initialPrice = 0;
                    let initialQuantity = partToFamily?.purchaseQuantity || 1;

                    if (vendorPart) {
                        if (vendorPart.costType === 0 && vendorPart.tieredCostFormulas && vendorPart.tieredCostFormulas.length > 0) {
                            const sortedTiers = [...vendorPart.tieredCostFormulas].sort((a, b) => a.quantity - b.quantity);
                            const tier = initialQuantity < sortedTiers[0].quantity 
                                ? sortedTiers[0] 
                                : [...sortedTiers].reverse().find(t => initialQuantity >= t.quantity) || sortedTiers[sortedTiers.length - 1];
                            initialPrice = normalizeUnitCost(tier.price);
                        } else {
                            initialPrice = normalizeUnitCost(vendorPart.basePrice / vendorPart.quantity);
                        }
                    }

                    filteredLogParts.splice(index + 1 + i, 0, {
                        id: uuid(),
                        familyId: family.id,
                        familyQuantity: 1,
                        partId: part.part.id,
                        partQuantity: initialQuantity,
                        description: part.part.description,
                        vendor: vendorName,
                        vendorId: vendorPart?.vendorId,
                        price: normalizeUnitCost(initialPrice),
                        total: calculateLineTotal(initialPrice, initialQuantity),
                        isFamilyRow: false,
                        isOverridden: false,
                        isFamilyPart: true,
                        vendorParts: part.part.vendorParts,
                        selectedOption: {
                            title: `${part.part.partId} rev ${part.part.revision}`,
                            value: part.part.id,
                            isFamily: false,
                            part: part.part
                        },
                        isModifying: false
                    });
                });

                this.setState({ newLogParts: filteredLogParts }, () => {
                    this.savePurchaseState();
                    // Autofocus the family quantity input field after family selection
                    setTimeout(() => {
                        const quantityInput = document.querySelector(`input[data-row-index="${index}"][data-field-type="family-quantity"]`);
                        if (quantityInput) {
                            quantityInput.focus();
                            quantityInput.select();
                        }
                    }, 100);
                });
            }
        } else {
            // Handle individual part selection
            const part = this.state.parts.find(x => x.part.id === newValue.value);
            if (part) {
                // Check if the selected part belongs to a family
                if (part.part.partToFamilies && part.part.partToFamilies.length > 0) {
                    // Only select the family if the part belongs to exactly one family
                    if (part.part.partToFamilies.length === 1) {
                        const familyId = part.part.partToFamilies[0].familyId;
                        const partFamily = this.state.partFamilies.find(f => f.id === familyId);
                        
                        if (partFamily) {
                            // Automatically select the family instead of the individual part
                            // Create a new value object for the family
                            const familyValue = {
                                title: `${partFamily.partFamilyId} (Family)`,
                                value: partFamily.id,
                                isFamily: true
                            };
                            
                            // Recursively call this method with the family value
                            this.handleFamilyChange(event, familyValue, index);
                            return;
                        }
                    }
                    // If part belongs to multiple families, select the part directly
                }
                const vendorPart = part.part.vendorParts.find(x => x.vendorId === part.part.selectedVendorId) || part.part.vendorParts[0];
                const vendorName = vendorPart ? this.state.vendors.find(x => x.id === vendorPart.vendorId)?.name : '';
                let initialPrice = 0;
                let initialQuantity = 1;

                if (vendorPart) {
                    if (vendorPart.costType === 0 && vendorPart.tieredCostFormulas?.length) {
                        const tierPrice = getTieredUnitPriceForQuantity(vendorPart, initialQuantity);
                        initialPrice = tierPrice ?? 0;
                    } else {
                        initialPrice = normalizeUnitCost(vendorPart.basePrice / vendorPart.quantity);
                        initialQuantity = vendorPart.quantity || initialQuantity;
                    }
                }

                newLogParts[index] = {
                    id: uuid(),
                    familyId: null,
                    familyQuantity: 1,
                    partId: part.part.id,
                    partQuantity: initialQuantity,
                    description: part.part.description,
                    vendor: vendorName,
                    vendorId: vendorPart?.vendorId,
                    price: normalizeUnitCost(initialPrice),
                    total: calculateLineTotal(initialPrice, initialQuantity),
                    isFamilyRow: false,
                    isOverridden: false,
                    isFamilyPart: false,
                    selectedOption: {
                        title: `${part.part.partId} rev ${part.part.revision}`,
                        value: part.part.id,
                        part: part.part
                    },
                    vendorParts: part.part.vendorParts
                };
                this.setState({ newLogParts }, () => {
                    this.savePurchaseState();
                    // Autofocus the part quantity input field after part selection
                    setTimeout(() => {
                        const quantityInput = document.querySelector(`input[data-row-index="${index}"][data-field-type="part-quantity"]`);
                        if (quantityInput) {
                            quantityInput.focus();
                            quantityInput.select();
                        }
                    }, 100);
                });
            }
        }
    };

        closeCopyTable = () => {
        this.setState({ 
            showCopyTable: false,
            copyTableData: [],
            copyTablesByVendor: {}
        });
    };

    copyVendorTableToClipboard = async (vendor, tableData) => {
        const tableHtml = `
            <table style="border-collapse: collapse; border: 1px solid black; font-family: Arial, sans-serif; font-size: 12px;">
                <thead>
                    <tr>
                        <th style="border: 1px solid black; padding: 8px; background-color: #f0f0f0; text-align: center;">Quantity</th>
                        <th style="border: 1px solid black; padding: 8px; background-color: #f0f0f0; text-align: center;">Item</th>
                    </tr>
                </thead>
                <tbody>
                    ${tableData.map(item => 
                        `<tr>
                            <td style="border: 1px solid black; padding: 8px; text-align: center;">${item.quantity}</td>
                            <td style="border: 1px solid black; padding: 8px; text-align: left;">${item.partNumber} rev ${item.revision}</td>
                        </tr>`
                    ).join('')}
                </tbody>
            </table>
        `;

        // Create plain text version as fallback
        const plainText = `Quantity\tItem\n${tableData.map(item => 
            `${item.quantity}\t${item.partNumber} rev ${item.revision}`
        ).join('\n')}`;

        try {
            // Try to copy HTML to clipboard
            if (window.ClipboardItem) {
                await navigator.clipboard.write([
                    new window.ClipboardItem({
                        'text/html': new Blob([tableHtml], { type: 'text/html' }),
                        'text/plain': new Blob([plainText], { type: 'text/plain' })
                    })
                ]);
                window.$alertSuccess(`${vendor} table copied to clipboard!`);
            } else {
                // Fallback if ClipboardItem is not available
                await navigator.clipboard.writeText(plainText);
                window.$alertSuccess(`${vendor} table copied to clipboard as text!`);
            }
        } catch (err) {
            console.error('Failed to copy table: ', err);
            window.$alertError("Failed to copy table to clipboard");
        }
    };

    copyTableToClipboard = async () => {
        // Create HTML table string
        const tableHtml = `
            <table style="width: 100%; border-collapse: collapse; border: 1px solid black; font-family: Arial, sans-serif; font-size: 12px;">
                <thead>
                    <tr>
                        <th style="border: 1px solid black; padding: 8px; background-color: #f0f0f0; text-align: center;">Quantity</th>
                        <th style="border: 1px solid black; padding: 8px; background-color: #f0f0f0; text-align: left;">Item</th>
                    </tr>
                </thead>
                <tbody>
                    ${this.state.copyTableData.map(item => 
                        `<tr>
                            <td style="border: 1px solid black; padding: 8px; text-align: center;">${item.quantity}</td>
                            <td style="border: 1px solid black; padding: 8px;">${item.partNumber} rev ${item.revision}</td>
                        </tr>`
                    ).join('')}
                </tbody>
            </table>
        `;

        // Create plain text version as fallback
        const plainText = `Quantity\tItem\n${this.state.copyTableData.map(item => 
            `${item.quantity}\t${item.partNumber} rev ${item.revision}`
        ).join('\n')}`;

        try {
            // Try to copy HTML to clipboard
            if (window.ClipboardItem) {
                await navigator.clipboard.write([
                    new window.ClipboardItem({
                        'text/html': new Blob([tableHtml], { type: 'text/html' }),
                        'text/plain': new Blob([plainText], { type: 'text/plain' })
                    })
                ]);
                window.$alertSuccess('Table copied to clipboard!');
            } else {
                // Fallback if ClipboardItem is not available
                await navigator.clipboard.writeText(plainText);
                window.$alertSuccess('Table copied to clipboard as text!');
            }
        } catch (err) {
            // Fallback to plain text if HTML clipboard fails
            try {
                await navigator.clipboard.writeText(plainText);
                window.$alertSuccess('Table copied to clipboard as text!');
            } catch (fallbackErr) {
                window.$alertError('Failed to copy to clipboard. Please copy manually.');
                console.error('Clipboard error:', fallbackErr);
            }
        }
    };

    render() {
        const {classes} = this.props;
        const self = this;
        if (this.state.loading) {
            return (
                <DashboardTemplate title="Inventory" onSyncDatabase={this.loadData}>
                    <div className="main-dashboard-root">
                        <CircularProgress/>
                    </div>
                </DashboardTemplate>
            );
        }

        const partsOptions = [
            ...this.state.partFamilies.map(family => ({
                title: `${family.partFamilyId} (Family)`,
                value: family.id,
                isFamily: true,
                family: family
            })),
            ...parts.map(part => ({
                title: `${part.part.partId} rev ${part.part.revision}`,
                value: part.part.id,
                isFamily: false,
                part: part.part
            }))
        ];

        let lastPartType = '';
        let lastManufacturerFor = '';
        let lastTertiaryType = '';

        return (
            <DashboardTemplate title="Inventory" onSyncDatabase={this.loadData}>
                <div className="main-dashboard-root">
                    <div className="container">
                        <div className={`${classes.toolbar} toolbar-responsive`}>
                            <div className={`${classes.toolbarLeft} toolbar-left`} style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1, maxWidth: '60%' }}>
                                {this.state.showingLogs === true ? (
                                    <TextField
                                        defaultValue=''
                                        onChange={this.searchLogs}
                                        label="Search logs..."
                                        variant="outlined"
                                        className="search-field"
                                        style={{minWidth: '300px'}}
                                        autoComplete="off"
                                    />
                                ) : (
                                    <TextField
                                        value={this.state.searchTerm}
                                        onChange={this.searchPart}
                                        label="Search PN, Description, Vendor..."
                                        variant="outlined"
                                        className="search-field"
                                        style={{minWidth: '300px'}}
                                        autoComplete="off"
                                        inputRef={ref => this.searchInputRef = ref}
                                    />
                                )}
                            </div>
                            
                            {/* Center: Navigation Buttons */}
                            <div className="toolbar-navigation" style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                                {this.state.showingLogs === true ? (
                                    <>
                                        <Button 
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {globalProps.history.push('/admin/inventory'); this.setState({showingLogs: false})}}
                                            className="success-button-lg action-button"
                                        >
                                            Go To Worksheet
                                        </Button>
                                        <Button 
                                            variant="contained"
                                            color="primary"
                                            onClick={this.openAddLog} 
                                            className="success-button-lg action-button"
                                        >
                                            Add Inventory Log
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <Button 
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {globalProps.history.push('/admin/inventory/logs'); this.setState({showingLogs: true})}}
                                            className="success-button-lg action-button"
                                        >
                                            Go To Inventory Logs
                                        </Button>
                                        {this.state.permissions.includes('EditAssembliesAndParts') && (
                                            <Button 
                                                variant="contained"
                                                color="primary"
                                                onClick={this.openSessionDrawer}
                                                className="success-button-lg action-button"
                                            >
                                                Start Session
                                            </Button>
                                        )}
                                    </>
                                )}
                            </div>
                            
                            <div className={`${classes.toolbarRight} toolbar-right`}>
                                {!this.state.showingLogs && (
                                    <>
                                        <div className={`${classes.filterToggle} filter-toggle`} onClick={this.toggleShowNonInventoryItems}>
                                            <Checkbox
                                                checked={this.state.showNonInventoryItems}
                                            />
                                            <span className={classes.filterLabel}>Show Non-Inventory Items</span>
                                        </div>
                                        <div className={`${classes.filterToggle} filter-toggle`} onClick={this.toggleShowLowInventoryOnly}>
                                            <Checkbox
                                                checked={this.state.showLowInventoryOnly}
                                            />
                                            <span className={classes.filterLabel}>Show Low Inventory</span>
                                        </div>
                                        <div className={`${classes.filterToggle} filter-toggle`} onClick={this.toggleShowCriticalEffectiveInventoryOnly}>
                                            <Checkbox
                                                checked={this.state.showCriticalEffectiveInventoryOnly}
                                            />
                                            <span className={classes.filterLabel}>Critical Effective Inventory</span>
                                        </div>
                                        {Object.keys(this.state.selectedParts).length > 0 && (
                                            <div className={`${classes.filterToggle} filter-toggle`} onClick={this.toggleShowOnlyPurchasing}>
                                                <Checkbox
                                                    checked={this.state.showOnlyPurchasing}
                                                />
                                                <span className={classes.filterLabel}>Show Only Purchasing</span>
                                            </div>
                                        )}
                                        <TextField
                                            label="Buffer (weeks)"
                                            variant="outlined"
                                            value={this.state.weeksToOrderBuffer}
                                            onChange={(event) => this.setState({
                                                weeksToOrderBuffer: event.target.value
                                            }, () => {
                                                this.saveFilterSettings();
                                            })}
                                            style={{width: 120}}
                                            type="number"
                                            autoComplete="off"
                                            size="small"
                                        />
                                    </>
                                )}
                            </div>
                        </div>
                        
                        {/* Order Calculation Method Controls - Centered between buttons and pagination */}
                        {!this.state.showingLogs && (
                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '10px 0 0', gap: '8px'}}>
                                <div style={{display: 'flex', alignItems: 'center', gap: '8px', border: '1px solid #ccc', borderRadius: '4px', padding: '8px'}}>
                                    <FormControl component="fieldset" size="small">
                                        <RadioGroup
                                            row
                                            value={this.state.orderCalculationMethod}
                                            onChange={(event) => this.setState({
                                                orderCalculationMethod: event.target.value
                                            }, () => {
                                                this.saveFilterSettings();
                                                this.syncSelectedPartsQuantitiesFromCalculation();
                                            })}
                                        >
                                            <FormControlLabel
                                                value="targetDate"
                                                control={<Radio size="small" />}
                                                label="Target Date"
                                                style={{marginRight: '16px'}}
                                            />
                                            <FormControlLabel
                                                value="desiredWeeks"
                                                control={<Radio size="small" />}
                                                label="Desired Weeks"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                    
                                    {this.state.orderCalculationMethod === 'targetDate' ? (
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <DatePicker
                                                label="Target Date"
                                                value={this.state.targetDate}
                                                onChange={(newValue) => this.setState({
                                                    targetDate: dayjs(newValue)
                                                }, () => {
                                                    this.saveFilterSettings();
                                                    this.syncSelectedPartsQuantitiesFromCalculation();
                                                })}
                                                renderInput={(params) => <TextField {...params} variant="outlined" size="small" style={{width: 150}} />}
                                                minDate={new Date()}
                                            />
                                        </MuiPickersUtilsProvider>
                                    ) : (
                                        <TextField
                                            label="Weeks"
                                            variant="outlined"
                                            value={this.state.desiredWeeksForOrder}
                                            onChange={(event) => this.setState({
                                                desiredWeeksForOrder: event.target.value
                                            }, () => {
                                                this.saveFilterSettings();
                                                this.syncSelectedPartsQuantitiesFromCalculation();
                                            })}
                                            style={{width: 100}}
                                            type="number"
                                            autoComplete="off"
                                            size="small"
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                        
                        {this.state.showingLogs === true ?
                            <div>
                                <center>
                                    <TablePagination
                                        rowsPerPageOptions={[50, 100, 200, 500]}
                                        colSpan={7}
                                        count={self.getFilteredInventoryLogs().length}
                                        rowsPerPage={this.state.logsRowsPerPage}
                                        page={this.state.logsPage}
                                        slotProps={{
                                            select: {
                                                'aria-label': 'rows per page',
                                            },
                                            actions: {
                                                showFirstButton: true,
                                                showLastButton: true,
                                                slots: {
                                                    firstPageIcon: FirstPageIcon,
                                                    lastPageIcon: LastPageIcon,
                                                    nextPageIcon: ChevronRightIcon,
                                                    backPageIcon: ChevronLeftIcon,
                                                },
                                            },
                                        }}
                                        onPageChange={this.handleLogsChangePage}
                                        onChangeRowsPerPage={this.handleLogsChangeRowsPerPage}
                                    />
                                </center>
                                <div className="parts-table-container">
                                    <table className="parts-table">
                                        <thead>
                                        <tr>
                                            <th style={{width: 50}}>
                                                <Checkbox
                                                    checked={(() => {
                                                        const paginatedLogs = self.getFilteredInventoryLogs().slice(
                                                            this.state.logsPage * this.state.logsRowsPerPage,
                                                            this.state.logsPage * this.state.logsRowsPerPage + this.state.logsRowsPerPage
                                                        );
                                                        return paginatedLogs.length > 0 && paginatedLogs.every(log =>
                                                            this.state.selectedLogIds.includes(log.id)
                                                        );
                                                    })()}
                                                    indeterminate={(() => {
                                                        const paginatedLogs = self.getFilteredInventoryLogs().slice(
                                                            this.state.logsPage * this.state.logsRowsPerPage,
                                                            this.state.logsPage * this.state.logsRowsPerPage + this.state.logsRowsPerPage
                                                        );
                                                        const selectedCount = paginatedLogs.filter(log =>
                                                            this.state.selectedLogIds.includes(log.id)
                                                        ).length;
                                                        return selectedCount > 0 && selectedCount < paginatedLogs.length;
                                                    })()}
                                                    onChange={this.handleSelectAllLogs}
                                                />
                                            </th>
                                            <th style={{width: 40}}>Edit</th>
                                            <SortableTableHeader field="logDate" sortField={this.state.logsSortField} sortDirection={this.state.logsSortDirection} onSort={this.handleInventoryLogsSort} style={{minWidth: 150}}>Date</SortableTableHeader>
                                            <SortableTableHeader field="user" sortField={this.state.logsSortField} sortDirection={this.state.logsSortDirection} onSort={this.handleInventoryLogsSort} style={{minWidth: 120}}>User</SortableTableHeader>
                                            <SortableTableHeader field="quantity" sortField={this.state.logsSortField} sortDirection={this.state.logsSortDirection} onSort={this.handleInventoryLogsSort} style={{minWidth: 80}}>Quantity</SortableTableHeader>
                                            <SortableTableHeader field="reason" sortField={this.state.logsSortField} sortDirection={this.state.logsSortDirection} onSort={this.handleInventoryLogsSort} style={{minWidth: 80}}>Reason</SortableTableHeader>
                                            <SortableTableHeader field="partNumber" sortField={this.state.logsSortField} sortDirection={this.state.logsSortDirection} onSort={this.handleInventoryLogsSort} style={{minWidth: 350}}>Part Number + Description</SortableTableHeader>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {self.getFilteredInventoryLogs().slice(this.state.logsPage * this.state.logsRowsPerPage, this.state.logsPage * this.state.logsRowsPerPage + this.state.logsRowsPerPage).map((inventoryLog) => {
                                            const part = this.state.parts.find(x => x.part.id === inventoryLog.partId);
                                            if (!part) return '';

                                            const adminUser = this.state.adminUsers.find(x => x.id === inventoryLog.userId);

                                            return (
                                                <tr key={inventoryLog.id}>
                                                    <td
                                                        onClick={(e) => {
                                                            const isCtrlPressed = e.ctrlKey || e.metaKey;
                                                            const isShiftPressed = e.shiftKey;
                                                            if (isCtrlPressed || isShiftPressed) {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
                                                                    e.nativeEvent.stopImmediatePropagation();
                                                                }
                                                                const syntheticEvent = {
                                                                    ctrlKey: isCtrlPressed,
                                                                    metaKey: e.metaKey,
                                                                    shiftKey: isShiftPressed,
                                                                    preventDefault: () => {},
                                                                    stopPropagation: () => {},
                                                                    target: { checked: !this.state.selectedLogIds.includes(inventoryLog.id) },
                                                                    nativeEvent: e.nativeEvent
                                                                };
                                                                this.handleSelectLog(inventoryLog.id, syntheticEvent);
                                                                return false;
                                                            }
                                                        }}
                                                        onMouseDown={(e) => {
                                                            const isCtrlPressed = e.ctrlKey || e.metaKey;
                                                            const isShiftPressed = e.shiftKey;
                                                            if (isCtrlPressed || isShiftPressed) {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
                                                                    e.nativeEvent.stopImmediatePropagation();
                                                                }
                                                            }
                                                        }}
                                                        style={{cursor: 'pointer'}}
                                                    >
                                                        <span
                                                            onClick={(e) => {
                                                                const isCtrlPressed = e.ctrlKey || e.metaKey;
                                                                const isShiftPressed = e.shiftKey;
                                                                if (isCtrlPressed || isShiftPressed) {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
                                                                        e.nativeEvent.stopImmediatePropagation();
                                                                    }
                                                                }
                                                            }}
                                                            style={{display: 'inline-block'}}
                                                        >
                                                            <Checkbox
                                                                checked={this.state.selectedLogIds.includes(inventoryLog.id)}
                                                                onChange={(e) => {
                                                                    if (this.state.isProcessingLogModifierClick) {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        return;
                                                                    }
                                                                    const isCtrlPressed = e.ctrlKey || e.metaKey;
                                                                    const isShiftPressed = e.shiftKey;
                                                                    if (isCtrlPressed || isShiftPressed) {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        return;
                                                                    }
                                                                    this.handleSelectLog(inventoryLog.id, e);
                                                                }}
                                                                onClick={(e) => {
                                                                    const isCtrlPressed = e.ctrlKey || e.metaKey;
                                                                    const isShiftPressed = e.shiftKey;
                                                                    if (isCtrlPressed || isShiftPressed) {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
                                                                            e.nativeEvent.stopImmediatePropagation();
                                                                        }
                                                                        return false;
                                                                    }
                                                                }}
                                                                style={{padding: 0}}
                                                            />
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <FontAwesomeIcon icon={faPencilAlt} size="1x"
                                                                         style={{
                                                                             width: 28,
                                                                             fontSize: 18,
                                                                             cursor: 'pointer'
                                                                         }}
                                                                         onClick={() => {
                                                                             this.editLog(inventoryLog)
                                                                         }}/>
                                                    </td>
                                                    <td>{formatUtcForDisplay(inventoryLog.logDate)}</td>
                                                    <td>{adminUser ? `${adminUser.firstName} ${adminUser.lastName}` : 'Unknown'}</td>
                                                    <td>{inventoryLog.quantity}</td>
                                                    <td className="text-left">{inventoryLog.reason}</td>
                                                    <td className="text-left">
                                                        {this.state.permissions.includes('EditAssembliesAndParts') ? (
                                                            <div style={{cursor: 'pointer'}} onClick={(event) => this.editPart(part, event.ctrlKey)}>
                                                                <PartDisplay 
                                                                    part={part.part}
                                                                    variant="table"
                                                                    classes={this.props.classes}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <PartDisplay 
                                                                part={part.part}
                                                                variant="table"
                                                                classes={this.props.classes}
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                                {this.state.bulkEditDrawerOpen ?
                                    <DrawerMenuRight title={"Bulk Edit Inventory Logs"} customWidth={500}
                                                     open={this.state.bulkEditDrawerOpen}
                                                     onClose={this.handleCloseBulkEditDrawer}>
                                        <div style={{padding: '20px'}}>
                                            <div style={{marginBottom: '20px'}}>
                                                <strong>{this.state.selectedLogIds.length}</strong> inventory log(s) selected
                                            </div>
                                            <div style={{marginBottom: '20px'}}>
                                                <TextField
                                                    label="Reason (leave blank for no change)"
                                                    variant="outlined"
                                                    value={this.state.bulkReason}
                                                    onChange={this.changeBulkReason}
                                                    style={{width: '100%'}}
                                                    inputProps={{maxLength: 100}}
                                                    multiline
                                                    rows={3}
                                                    autoComplete="off"
                                                />
                                            </div>
                                            <div style={{display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '30px'}}>
                                                <Button
                                                    variant="outlined"
                                                    onClick={this.handleCloseBulkEditDrawer}
                                                    disabled={this.state.bulkProcessing}
                                                >
                                                    Cancel
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={this.applyBulkReason}
                                                    disabled={this.state.bulkProcessing}
                                                >
                                                    {this.state.bulkProcessing ? <CircularProgress size={20} /> : 'Save Changes'}
                                                </Button>
                                            </div>
                                        </div>
                                    </DrawerMenuRight>
                                    : ""}
                                {this.state.selectedLogIds.length > 0 && (
                                    <div style={{
                                        position: 'fixed',
                                        bottom: 20,
                                        left: 182,
                                        right: 0,
                                        zIndex: 1000,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: '16px',
                                        pointerEvents: 'none'
                                    }}>
                                        <div style={{display: 'flex', gap: '16px', pointerEvents: 'auto'}}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={this.clearLogSelection}
                                                className="success-button-lg"
                                            >
                                                Deselect All
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={this.openBulkEditDrawer}
                                                className="success-button-lg"
                                            >
                                                Bulk Edit ({this.state.selectedLogIds.length})
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                onClick={this.bulkDeleteLogs}
                                                className="delete-button-lg"
                                                disabled={this.state.bulkProcessing}
                                            >
                                                Delete Selected ({this.state.selectedLogIds.length})
                                            </Button>
                                        </div>
                                    </div>
                                )}
                                {this.state.addingLogOpen ?
                                    <DrawerMenuRight title={"Add Inventory Log"} customWidth={520}
                                                     open={this.state.addingLogOpen}
                                                     onClose={this.handleCloseNewLog}
                                                     hasUnsavedChanges={
                                                         this.state.newLogEntries.some(entry => entry.part || parseNumberInputValue(entry.quantity) !== 0) ||
                                                         this.state.newLogReason !== ''
                                                     }
                                                     onSubmit={this.addInventoryLog}
                                                     submitConfirmMessage="Are you sure you want to add these inventory logs?"
                                                     disableEnterKeySubmit
                                                     >
                                        <div style={{marginBottom: 20}}>
                                            <h3 style={{margin: '0 0 12px 0', color: '#333', fontSize: 16}}>Log information</h3>
                                            <div style={{width: '100%', marginBottom: 16}}>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <DateTimePicker
                                                        label="Log Date"
                                                        value={this.state.newLogDate}
                                                        onChange={(newValue) => this.setState({newLogDate: newValue, newLogDateManuallyChanged: true})}
                                                        renderInput={(params) => (
                                                            <TextField {...params} variant="outlined" fullWidth />
                                                        )}
                                                        style={{width: '100%'}}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </div>
                                            <TextField value={this.state.newLogReason}
                                                       onChange={this.changeReason} label="Reason" variant="outlined"
                                                       style={{width: '100%'}} inputProps={{maxLength: 5000}}
                                                       autoComplete="off"/>
                                        </div>
                                        <div style={{marginBottom: 20}}>
                                            <h3 style={{margin: '0 0 12px 0', color: '#333', fontSize: 16}}>Items</h3>
                                            {(this.state.newLogEntries || []).map((entry, index) => (
                                                <div key={entry.id} data-inventory-entry-index={index} style={{
                                                    display: 'flex',
                                                    gap: '10px',
                                                    alignItems: 'center',
                                                    marginBottom: '10px',
                                                    padding: '10px',
                                                    border: '1px solid #e0e0e0',
                                                    borderRadius: '4px',
                                                    backgroundColor: '#fafafa'
                                                }}>
                                                    <div style={{flex: '2'}}>
                                                        <Autocomplete
                                                            autoHighlight
                                                            options={partsOptions}
                                                            onChange={(event, newValue) => this.handleNewLogPartChange(index, newValue)}
                                                            value={entry.part && typeof entry.part === 'object' ? (partsOptions.find(opt => (opt.isFamily && opt.value === entry.part.value) || (!opt.isFamily && opt.value === entry.part.value)) || { title: entry.part.title, value: entry.part.value, isFamily: entry.part.isFamily }) : null}
                                                            getOptionLabel={(option) => {
                                                                if (option.family) return option.family.partFamilyId;
                                                                if (option.part) return `${option.part.partId} rev ${option.part.revision}`;
                                                                return option.title || '';
                                                            }}
                                                            getOptionSelected={(option, value) => option && value && option.value === value.value}
                                                            className="autocomplete-dropdown"
                                                            renderOption={(option) => <PartAutocompleteOption option={option} classes={this.props.classes} />}
                                                            renderInput={(params) => (
                                                                <TextField {...params} label="Part" autoComplete="new-password" variant="outlined" size="small" />
                                                            )}
                                                        />
                                                    </div>
                                                    <div style={{flex: '1'}}>
                                                        <TextField
                                                            label="Quantity (+/-)"
                                                            variant="outlined"
                                                            type="number"
                                                            value={getNumberInputDisplayValue(entry.quantity)}
                                                            onChange={(e) => this.handleNewLogQuantityChange(index, e)}
                                                            onKeyDown={(e) => this.handleNewLogQuantityKeyDown(index, e)}
                                                            size="small"
                                                            fullWidth
                                                            inputProps={{'data-inventory-entry-index': index}}
                                                        />
                                                    </div>
                                                    {this.state.newLogEntries.length > 1 && (
                                                        <div>
                                                            <Button
                                                                variant="outlined"
                                                                color="secondary"
                                                                size="small"
                                                                onClick={() => this.removeNewLogEntry(index)}
                                                                style={{minWidth: '40px'}}
                                                            >
                                                                ×
                                                            </Button>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                        {this.state.savingLog === true ? (
                                            <CircularProgress/>
                                        ) : (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={this.addInventoryLog}
                                                className="success-button-lg"
                                                disabled={!this.state.newLogEntries.some(entry => entry.part)}
                                            >
                                                Confirm All Entries ({this.state.newLogEntries.filter(entry => entry.part).length} items)
                                            </Button>
                                        )}
                                    </DrawerMenuRight>
                                    : ""}
                                {this.state.editLogOpen ?
                                    <DrawerMenuRight title={"Edit Inventory Log"} customWidth={400}
                                                     open={this.state.editLogOpen}
                                                     onClose={this.handleCloseEditLog}
                                                     hasUnsavedChanges={this.hasEditLogUnsavedChanges()}
                                                     onSubmit={this.saveInventoryLog}
                                                     submitConfirmMessage="Are you sure you want to save these changes?"
                                                     >
                                        <Autocomplete
                                            value={this.state.parts.find(x => x.part.id === this.state.editingLog.partId)}
                                            onChange={this.editLogPart}
                                            options={this.state.parts}
                                            getOptionLabel={(option) => `${option.part.partId} rev ${option.part.revision}`}
                                            isOptionEqualToValue={(option, value) => option.part.id === value.part.id}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Part"
                                                    variant="outlined"
                                                    style={{width: '100%', marginBottom: 20}}
                                                />
                                            )}
                                        />
                                        <TextField value={getNumberInputDisplayValue(this.state.editingLog.quantity)}
                                                   onChange={this.editQuantity} label={"Quantity (+/-)"}
                                                   variant="outlined" type="number"
                                                   style={{width: '100%', marginBottom: 15}}
                                                   autoComplete="off"/>
                                        <div style={{width: '100%', marginBottom: 20}}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <DateTimePicker
                                                    label="Log Date"
                                                    value={fromUtcForDisplay(this.state.editingLog.logDate)}
                                                    onChange={(newValue) => {
                                                        this.setState({
                                                            editingLog: {
                                                                ...this.state.editingLog,
                                                                logDate: newValue
                                                            }
                                                        });
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField 
                                                            {...params} 
                                                            variant="outlined" 
                                                            fullWidth
                                                        />
                                                    )}
                                                    style={{width: '100%'}}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>
                                        <TextField value={this.state.editingLog.reason}
                                                   onChange={this.editReason} label={"Reason"} variant="outlined"
                                                   style={{width: '100%', marginBottom: 20}} inputProps={{maxLength: 100}}
                                                   autoComplete="off"/>
                                        <div style={{display: 'flex', gap: '10px', justifyContent: 'center'}}>
                                            {this.state.savingLog === true ?
                                                <CircularProgress/>
                                                :
                                                <Button 
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={this.saveInventoryLog}
                                                    className="success-button-lg" 
                                                    style={{width: 150, display: 'inline-block'}}
                                                >
                                                    Save
                                                </Button>
                                            }
                                            {this.state.deletingLog === true ?
                                                <CircularProgress/>
                                                :
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    className='delete-button-lg'
                                                    onClick={this.deleteInventoryLog}
                                                    disabled={this.state.savingLog}
                                                >
                                                    Delete
                                                </Button>
                                            }
                                        </div>
                                    </DrawerMenuRight>
                                    : ""}
                            </div>
                            :
                            <div>
                                <center>
                                    <TablePagination
                                        rowsPerPageOptions={[50, 100, 200, 500]}
                                        colSpan={4}
                                        count={this.getFilteredPurchaseParts().length}
                                        rowsPerPage={this.state.rowsPerPage}
                                        page={this.state.page}
                                        slotProps={{
                                            select: {
                                                'aria-label': 'rows per page',
                                            },
                                            actions: {
                                                showFirstButton: true,
                                                showLastButton: true,
                                                slots: {
                                                    firstPageIcon: FirstPageIcon,
                                                    lastPageIcon: LastPageIcon,
                                                    nextPageIcon: ChevronRightIcon,
                                                    backPageIcon: ChevronLeftIcon,
                                                },
                                            },
                                        }}
                                        onPageChange={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </center>
                                <div className="parts-table-container">
                                    <table className="parts-table inventory-table">
                                        <thead>
                                        <tr>
                                            <th style={{minWidth: 350, height: 50}}>Part Number + Description</th>
                                            <th style={{minWidth: 120}}>Vendor</th>
                                            <th style={{minWidth: 65}}>Inventory<br/>Strategy</th>
                                            <th style={{minWidth: 80}}>4 week<br/>Sales / wk</th>
                                            <th style={{minWidth: 80}}>24 week<br/>Sales / wk</th>
                                            <th style={{minWidth: 60}}>Total<br/>Received</th>
                                            <th style={{minWidth: 60}}>Total<br/>Sold</th>
                                            <th style={{minWidth: 60}}>Total<br/>Unpckgd</th>
                                            <th style={{minWidth: 60}}>Total in<br/>FG/SubA</th>
                                            <th style={{minWidth: 65}}>Packaging<br/>Deficit</th>
                                            <th style={{minWidth: 65}}>Effective<br/>Inventory</th>
                                            {this.state.showCriticalEffectiveInventoryOnly ? (
                                                <th style={{minWidth: 65}}>Critical Inv.<br/>Quantity</th>
                                            ) : null}
                                            <th style={{minWidth: 50}}>Min Qty</th>
                                            <th style={{minWidth: 60}}>On Order</th>
                                            <th style={{minWidth: 75}}>Earliest ETA</th>
                                            <th style={{minWidth: 60}}>In Transit</th>
                                            <th style={{minWidth: 65}}>Weeks of<br/>Stock</th>
                                            <th style={{minWidth: 65}}>Lead Time</th>
                                            <th style={{minWidth: 105}}>Weeks to Order</th>
                                            {this.state.showCriticalEffectiveInventoryOnly ? (
                                                <th style={{minWidth: 65}}>Critical Inv.<br/>Weeks</th>
                                            ) : null}
                                            <th style={{minWidth: 115}}>Number to Order</th>
                                            <th style={{minWidth: 65}}>Purchase</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.getFilteredPurchaseParts().slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((partExpanded) => {
                                            const part = partExpanded.part;
                                            if (!part || !part.isActive) return '';

                                            const { minQuantity, effectiveInventory, packagingDeficit } = this.getWorksheetOrderQuantityInputs(partExpanded);

                                            const aggregatedSupersedesData = this.getAggregatedSupersedesSales(partExpanded);
                                            const combinedEffectiveInventory = this.getCombinedEffectiveInventoryForWorksheet(
                                                partExpanded,
                                                effectiveInventory
                                            );

                                            let combinedAverageSalesPerWeek = partExpanded.averageSalesPerWeek;

                                            if (aggregatedSupersedesData) {
                                                const combinedFourWeekSales = partExpanded.fourWeekAvgSales + aggregatedSupersedesData.fourWeekSales;
                                                const combinedTwentyFourWeekSales = partExpanded.twentyFourWeekAvgSales + aggregatedSupersedesData.twentyFourWeekSales;
                                                combinedAverageSalesPerWeek = (combinedFourWeekSales + combinedTwentyFourWeekSales) / 2;
                                            }

                                            let weeksOfStock;
                                            let weeksToOrder;

                                            weeksOfStock = "∞";
                                            if (partExpanded.fourWeekAvgSales > 0 || partExpanded.twentyFourWeekAvgSales > 0) {
                                                weeksOfStock = Math.floor((effectiveInventory + partExpanded.onOrder - minQuantity) / partExpanded.averageSalesPerWeek);
                                            }

                                            weeksToOrder = "∞";
                                            if (aggregatedSupersedesData) {
                                                    // Use combined data for weeks to order calculation when superseded data exists
                                                    const combinedWeeksOfStock = Math.floor((combinedEffectiveInventory + partExpanded.onOrder - minQuantity) / combinedAverageSalesPerWeek);
                                                    weeksToOrder = Number.parseFloat(combinedWeeksOfStock) - part.leadTimeInWeeks - this.state.weeksToOrderBuffer;
                                                
                                                
                                                if (partExpanded.totalSold === 0 && part.supersedesId) {
                                                    // If this part has no sales but supersedes another part that does have sales, use the superseded part's minQuantity
                                                    const supersededPart = this.state.parts.find(x => x.part.id === part.supersedesId);
                                                    if (supersededPart && (supersededPart.totalSold > 0 || this.hasSupersedesChainWithSales(supersededPart))) {
                                                        // Calculate minQuantity for the superseded part
                                                        // Since we're using aggregated data from the entire chain, use the minQuantity from the part that has sales
                                                        let supersededMinQuantity = 0;
                                                        
                                                        // Find the part in the chain that has sales and use its minQuantity
                                                        const findSalesPartInChain = (partId) => {
                                                            const part = this.state.parts.find(x => x.part.id === partId);
                                                            if (!part) return null;
                                                            if (part.totalSold > 0) return part;
                                                            if (part.part.supersedesId) {
                                                                return findSalesPartInChain(part.part.supersedesId);
                                                            }
                                                            return null;
                                                        };
                                                        
                                                        const salesPart = findSalesPartInChain(part.supersedesId);
                                                        if (salesPart) {
                                                            // Calculate minQuantity for the sales part using the same logic as the main table
                                                            let salesPartMinQuantity = 0;
                                                            if (salesPart.part.inventoryStrategy === "B") {
                                                                // Strategy B logic (complex calculation with assemblies)
                                                                this.state.subAssemblies.forEach((subAssembly) => {
                                                                    const assemblyPart = subAssembly.subAssembly.partsToSubAssemblies.find(x => x.partFk === salesPart.part.id);
                                                                    if (assemblyPart) {
                                                                        const averageSalesFourAndTwentyFour = (subAssembly.fourWeekSalesPerWeekWithRev + subAssembly.twentyFourWeekSalesPerWeekWithRev) / 2;
                                                                        let minAssembledOnHand = 2 * averageSalesFourAndTwentyFour;
                                                                        salesPartMinQuantity += Math.ceil(minAssembledOnHand) * assemblyPart.quantity;
                                                                    }
                                                                });
                                                                this.state.assemblies.forEach((assembly) => {
                                                                    const assemblyPart = assembly.assembly.partsToAssemblies.find(x => x.partFk === salesPart.part.id);
                                                                    if (assemblyPart) {
                                                                        const averageSalesFourAndTwentyFour = (assembly.fourWeekSalesPerWeekWithRev + assembly.twentyFourWeekSalesPerWeekWithRev) / 2;
                                                                        let minAssembledOnHand = 2 * averageSalesFourAndTwentyFour;
                                                                        salesPartMinQuantity += Math.ceil(minAssembledOnHand) * assemblyPart.quantity;
                                                                    }
                                                                });
                                                            } else {
                                                                // Strategy A logic (simple calculation)
                                                                this.state.subAssemblies.forEach((subAssembly) => {
                                                                    const assemblyPart = subAssembly.subAssembly.partsToSubAssemblies.find(x => x.partFk === salesPart.part.id);
                                                                    if (assemblyPart) {
                                                                        const averageSalesFourAndTwentyFour = (subAssembly.fourWeekSalesPerWeekWithRev + subAssembly.twentyFourWeekSalesPerWeekWithRev) / 2;
                                                                        let minAssembledOnHand = 2 * averageSalesFourAndTwentyFour;
                                                                        salesPartMinQuantity += Math.ceil(minAssembledOnHand) * assemblyPart.quantity;
                                                                    }
                                                                });
                                                                this.state.assemblies.forEach((assembly) => {
                                                                    const assemblyPart = assembly.assembly.partsToAssemblies.find(x => x.partFk === salesPart.part.id);
                                                                    if (assemblyPart) {
                                                                        const averageSalesFourAndTwentyFour = (assembly.fourWeekSalesPerWeekWithRev + assembly.twentyFourWeekSalesPerWeekWithRev) / 2;
                                                                        let minAssembledOnHand = 2 * averageSalesFourAndTwentyFour;
                                                                        salesPartMinQuantity += Math.ceil(minAssembledOnHand) * assemblyPart.quantity;
                                                                    }
                                                                });
                                                            }
                                                            supersededMinQuantity = salesPartMinQuantity;
                                                        }
                                                        
                                                        if (supersededMinQuantity < salesPart.part.minimumQuantity) {
                                                            supersededMinQuantity = salesPart.part.minimumQuantity;
                                                        }

                                                        // Calculate weeks to order using superseded part's minQuantity
                                                        // Use the aggregated sales data for the calculation
                                                        const combinedFourWeekSales = partExpanded.fourWeekAvgSales + aggregatedSupersedesData.fourWeekSales;
                                                        const combinedTwentyFourWeekSales = partExpanded.twentyFourWeekAvgSales + aggregatedSupersedesData.twentyFourWeekSales;
                                                        const combinedAverageSalesPerWeek = (combinedFourWeekSales + combinedTwentyFourWeekSales) / 2;
                                                        
                                                        const supersededWeeksOfStock = Math.floor((combinedEffectiveInventory + supersededPart.onOrder + partExpanded.onOrder - supersededMinQuantity) / combinedAverageSalesPerWeek);
                                                        if (supersededWeeksOfStock !== "∞") {
                                                            weeksToOrder = Math.ceil(Number.parseFloat(supersededWeeksOfStock) - part.leadTimeInWeeks - this.state.weeksToOrderBuffer);
                                                        }
                                                    }
                                                }
                                                } else if (weeksOfStock !== "∞") {
                                                    weeksToOrder = Math.ceil(Number.parseFloat(weeksOfStock) - part.leadTimeInWeeks - this.state.weeksToOrderBuffer);
                                                }

                                            let weeksToOrderCell = this.getWeeksToOrderCellState(partExpanded, effectiveInventory, minQuantity, weeksToOrder);

                                            const criticalEffectiveInventory = this.state.showCriticalEffectiveInventoryOnly
                                                ? this.evaluateCriticalEffectiveInventory(partExpanded)
                                                : null;
                                            const inTransit = this.state.inTransitByPartId[part.id] || 0;

                                            const partPurchaseLogs = this.state.purchaseLogs.filter(x => x.partId === part.id && x.quantityReceived < x.quantity).sort(function (a, b) {
                                                return new Date(b.orderDate) - new Date(a.orderDate);
                                            });

                                            let partTypeHeader = [];
                                            if (part.partType !== lastPartType) {
                                                lastPartType = part.partType;
                                                partTypeHeader.push(<tr className="part-type-header">
                                                    <td colSpan={this.state.showAdvancedInfo ? (this.state.showCriticalEffectiveInventoryOnly ? 38 : 36) : (this.state.showCriticalEffectiveInventoryOnly ? 29 : 27)} style={{
                                                        backgroundColor: '#f5f5f5',
                                                        fontWeight: 'bold',
                                                        padding: '8px',
                                                        borderBottom: '1px solid #ddd'
                                                    }} className='text-left'>{lastPartType}</td>
                                                </tr>);
                                            }

                                            let manufacturerForHeader = [];
                                            if (part.manufacturerFor !== lastManufacturerFor) {
                                                lastManufacturerFor = part.manufacturerFor;
                                                manufacturerForHeader.push(<tr className="manufacturer-header">
                                                    <td colSpan={this.state.showAdvancedInfo ? (this.state.showCriticalEffectiveInventoryOnly ? 38 : 36) : (this.state.showCriticalEffectiveInventoryOnly ? 29 : 27)} style={{
                                                        backgroundColor: '#e8e8e8',
                                                        fontWeight: 'bold',
                                                        padding: '8px',
                                                        borderBottom: '1px solid #ddd'
                                                    }} className='text-left'>{lastManufacturerFor}</td>
                                                </tr>);
                                            }

                                            let tertiaryTypeHeader = [];
                                            if (part.tertiaryType !== lastTertiaryType) {
                                                // Show header if there's actually a tertiary type
                                                if (part.tertiaryType && part.tertiaryType.trim() !== '') {
                                                    tertiaryTypeHeader.push(
                                                        <tr className="tertiary-type-header">
                                                            <td colSpan={this.state.showAdvancedInfo ? (this.state.showCriticalEffectiveInventoryOnly ? 38 : 36) : (this.state.showCriticalEffectiveInventoryOnly ? 29 : 27)} className='text-left' style={{ backgroundColor: '#767676', fontWeight: 'bold', padding: '2px 4px', borderBottom: '1px solid #ccc' }}>
                                                                {part.tertiaryType}
                                                            </td>
                                                        </tr>
                                                    );
                                                } else if (lastTertiaryType && lastTertiaryType.trim() !== '') {
                                                    // Add an empty/clearing header when transitioning from tertiary type back to no tertiary type
                                                    tertiaryTypeHeader.push(
                                                        <tr className="tertiary-type-header">
                                                            <td colSpan={this.state.showAdvancedInfo ? (this.state.showCriticalEffectiveInventoryOnly ? 38 : 36) : (this.state.showCriticalEffectiveInventoryOnly ? 29 : 27)} className='text-left' style={{ backgroundColor: 'transparent', height: '1px', padding: '0', borderBottom: 'none' }}>
                                                                &nbsp;
                                                            </td>
                                                        </tr>
                                                    );
                                                }
                                                lastTertiaryType = part.tertiaryType;
                                            }

                                            const worksheetVendorPart = part.vendorParts?.find(x => x.vendorId === part.selectedVendorId) || part.vendorParts?.[0];
                                            const showWorksheetTieredTooltip = worksheetVendorPart?.costType === 0 && worksheetVendorPart?.tieredCostFormulas?.length > 0;

                                            return (
                                                <React.Fragment>
                                                    {partTypeHeader}
                                                    {manufacturerForHeader}
                                                    {tertiaryTypeHeader}
                                                    <tr style={{opacity: !part.supersededById ? 1 : 0.5}}>
                                                        <td className="text-left">
                                                            {this.state.permissions.includes('EditAssembliesAndParts') ? (
                                                                <div style={{cursor: 'pointer'}} onClick={(event) => this.editPart(partExpanded, event.ctrlKey)}>
                                                                    <PartDisplay 
                                                                        part={part}
                                                                        variant="table"
                                                                        classes={this.props.classes}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <PartDisplay 
                                                                    part={part}
                                                                    variant="table"
                                                                    classes={this.props.classes}
                                                                />
                                                            )}
                                                        </td>
                                                        <td className="text-left">{this.getVendorName(part.selectedVendorId)}</td>
                                                        <td>{part.inventoryStrategy}</td>
                                                        <td style={{fontWeight: 'bold', fontSize: 16}}>{partExpanded.fourWeekAvgSales.toFixed(2)}</td>
                                                        <td style={{fontWeight: 'bold', fontSize: 16}}>{partExpanded.twentyFourWeekAvgSales.toFixed(2)}</td>
                                                        <td>{partExpanded.totalReceived}</td>
                                                        <td>{partExpanded.totalSold}</td>
                                                        <td>{partExpanded.totalUnpackaged}</td>
                                                        <td>{partExpanded.totalInFG}</td>
                                                        <td>{packagingDeficit}</td>
                                                        <td style={{fontWeight: 'bold', fontSize: 16}}>{effectiveInventory}</td>
                                                        {this.state.showCriticalEffectiveInventoryOnly ? (
                                                            <td style={{fontWeight: 'bold', fontSize: 16}}>{criticalEffectiveInventory.criticalInventoryQuantity}</td>
                                                        ) : null}
                                                        <td>{minQuantity}</td>
                                                        <td>{partExpanded.onOrder}</td>
                                                        <td>{partExpanded.onOrder > 0 ? addDays(new Date(partPurchaseLogs[0] ? partPurchaseLogs[0].orderDate : new Date()), (part.leadTimeInWeeks * 7)).toISOString().split('T')[0] : ''}</td>
                                                        <td>{inTransit}</td>
                                                        <td>{weeksOfStock}</td>
                                                        <td>{part.leadTimeInWeeks}</td>
                                                        <td style={{
                                                            backgroundColor: weeksToOrderCell.color,
                                                            fontWeight: 'bold',
                                                            fontSize: weeksToOrderCell.isMinQtyReorder ? 13 : 16
                                                        }}>{weeksToOrderCell.display}</td>
                                                        {this.state.showCriticalEffectiveInventoryOnly ? (
                                                            <td
                                                                style={{
                                                                    backgroundColor: criticalEffectiveInventory.color,
                                                                    fontWeight: 'bold',
                                                                    fontSize: 16,
                                                                }}
                                                                title="Weeks until stockout using critical inventory quantity (effective + in transit; on-order not on packing slip excluded)"
                                                            >
                                                                {criticalEffectiveInventory.criticalInventoryWeeks}
                                                            </td>
                                                        ) : null}
                                                        <td>
                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                                                                <TextField
                                                                    value={this.getResolvedOrderQuantityForPartId(part.id)}
                                                                    onChange={(event) => this.handleQuantityOverride(part.id, event.target.value)}
                                                                    onKeyDown={(event) => this.handleWorksheetQuantityKeyDown(event, part.id)}
                                                                    variant="outlined"
                                                                    style={{
                                                                        width: 60,
                                                                        flexShrink: 0
                                                                    }}
                                                                    inputProps={{
                                                                        style: { 
                                                                            textAlign: 'center',
                                                                            fontWeight: 'bold'
                                                                        },
                                                                        'data-part-id': `worksheet-${part.id}`
                                                                    }}
                                                                    autoComplete="off"
                                                                />
                                                                {showWorksheetTieredTooltip && (
                                                                    <FontAwesomeIcon
                                                                        icon={faInfoCircle}
                                                                        style={{ cursor: 'help', flexShrink: 0 }}
                                                                        title={this.getTieredPricingTooltip(worksheetVendorPart)}
                                                                    />
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td style={{textAlign: 'center', paddingTop: 4}}>
                                                            <Checkbox
                                                                checked={!!this.state.selectedParts[part.id]}
                                                                onChange={(event) => {
                                                                    const quantity = this.getResolvedOrderQuantityForPartId(part.id);
                                                                    this.handlePartSelection(part.id, event.target.checked ? quantity : 0);
                                                                }}
                                                                style={{padding: '0px 4px 2px'}}
                                                            />
                                                        </td>
                                                    </tr>
                                                </React.Fragment>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                                {Object.keys(this.state.selectedParts).length > 0 && (
                                    <div style={{
                                        position: 'fixed',
                                        bottom: 20,
                                        left: 'calc(50% + 100px)',
                                        transform: 'translateX(-50%)',
                                        zIndex: 1000,
                                        display: 'flex',
                                        gap: '16px',
                                        alignItems: 'center'
                                    }}>
                                        <Button
                                            color="secondary"
                                            className="delete-button-lg"
                                            onClick={this.clearSavedPurchaseState}
                                        >
                                            Reset All
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={this.openPurchaseDrawer}
                                            className="success-button-lg"
                                        >
                                            Purchase {Object.keys(this.state.selectedParts).length} Parts
                                        </Button>
                                    </div>
                                )}

                                <DrawerMenuRight
                                    open={this.state.purchaseDrawerOpen}
                                    onClose={this.closePurchaseDrawer}
                                    title="Purchase Parts"
                                    customWidth={1400}
                                    hasUnsavedChanges={
                                        this.state.newLogParts.length > 0 ||
                                        this.state.newVendorOrderNumber !== ''
                                    }
                                >
                                    <div style={{padding: '20px'}}>
                                        <div style={{marginBottom: 20, width: '22%', display: 'inline-block'}}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <DatePicker
                                                    label="Order Date"
                                                    value={this.state.newPurchaseOrderDate}
                                                    onChange={(newValue) => this.setState({newPurchaseOrderDate: newValue})}
                                                    renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>
                                        <div style={{marginBottom: 20, width: '24%', display: 'inline-block'}}>
                                            <TextField
                                                label="Vendor Order Number (Optional)"
                                                value={this.state.newVendorOrderNumber}
                                                onChange={(event) => this.setState({newVendorOrderNumber: event.target.value})}
                                                variant="outlined"
                                                style={{width: '100%'}}
                                                inputProps={{maxLength: 200}}
                                                autoComplete="off"
                                            />
                                        </div>
                                        <div className="parts-table-container">
                                            <table className="parts-table">
                                                <thead>
                                                    <tr>
                                                        <th style={{minWidth: 300}}>PN + Description</th>
                                                        <th style={{minWidth: 80}}>Qty</th>
                                                        <th style={{minWidth: 90}}>Vendor</th>
                                                        <th style={{minWidth: 120}}>Price</th>
                                                        <th style={{minWidth: 90}}>Total</th>
                                                        <th style={{minWidth: 80}}></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.newLogParts.map((row, index) => {
                                                        if (row.isFamilyRow) {
                                                            return (
                                                                <tr key={row.id}>
                                                                    <td>
                                                                        {console.log(`Row ${row.partId} - selectedOption:`, row.selectedOption, 'isModifying:', row.isModifying)}
                                                                        {row.selectedOption && !row.isModifying ? (
                                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                                <div style={{cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px'}} onClick={() => this.handlePartDisplayClick(index)}>
                                                                                    {row.isFamilyRow && <FontAwesomeIcon icon={faPeopleCarry} style={{ color: '#2196F3' }} />}
                                                                                    <PartDisplay 
                                                                                        part={{
                                                                                            partId: row.isFamilyRow 
                                                                                                ? (row.selectedOption.family?.partFamilyId || row.selectedOption.family?.description || row.partId || `Family ${row.familyId}`)
                                                                                                : (row.selectedOption.part?.part.partId || row.partId),
                                                                                            revision: row.isFamilyRow ? '' : (row.selectedOption.part?.part.revision || ''),
                                                                                            description: row.isFamilyRow 
                                                                                                ? (row.selectedOption.family?.description || row.description)
                                                                                                : (row.selectedOption.part?.part.description || row.description)
                                                                                        }}
                                                                                        debug={console.log('PartDisplay data for', row.partId, ':', {
                                                                                            isFamilyRow: row.isFamilyRow,
                                                                                            selectedOption: row.selectedOption,
                                                                                            partId: row.selectedOption?.part?.part?.partId || row.partId,
                                                                                            revision: row.selectedOption?.part?.part?.revision || '',
                                                                                            description: row.selectedOption?.part?.part?.description || row.description
                                                                                        })}
                                                                                        variant="table"
                                                                                        classes={this.props.classes}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            <Autocomplete autoHighlight
                                                                                options={partsOptions}
                                                                                getOptionLabel={(option) => {
                                                                                    if (option.family) {
                                                                                        return option.family.partFamilyId;
                                                                                    } else if (option.part) {
                                                                                        return `${option.part.partId} rev ${option.part.revision}`;
                                                                                    }
                                                                                    return option.title || '';
                                                                                }}
                                                                                value={row.selectedOption}
                                                                                onChange={(event, newValue) => {
                                                                                    // Check if the new value is a family or an individual part
                                                                                    if (newValue && newValue.isFamily) {
                                                                                        // If changing from an existing family, remove old child parts first
                                                                                        const currentRow = this.state.newLogParts[index];
                                                                                        if (currentRow.familyId && currentRow.isFamilyRow) {
                                                                                            const oldFamilyId = currentRow.familyId;
                                                                                            const updatedRows = this.state.newLogParts.filter((row, i) => 
                                                                                                i === index || row.familyId !== oldFamilyId
                                                                                            );
                                                                                            this.setState({ newLogParts: updatedRows }, () => {
                                                                                                this.handleFamilyChange(event, newValue, index);
                                                                                                setTimeout(() => {
                                                                                                    const updatedRows2 = [...this.state.newLogParts];
                                                                                                    updatedRows2[index].isModifying = false;
                                                                                                    this.setState({ newLogParts: updatedRows2 });
                                                                                                }, 0);
                                                                                            });
                                                                                        } else {
                                                                                            this.handleFamilyChange(event, newValue, index);
                                                                                            setTimeout(() => {
                                                                                                const updatedRows = [...this.state.newLogParts];
                                                                                                updatedRows[index].isModifying = false;
                                                                                                this.setState({ newLogParts: updatedRows });
                                                                                            }, 0);
                                                                                        }
                                                                                    } else if (newValue && newValue.part) {
                                                                                        // It's an individual part, remove child parts and convert to part row
                                                                                        let updatedRows = [...this.state.newLogParts];
                                                                                        const currentRow = updatedRows[index];
                                                                                        
                                                                                        if (currentRow.familyId) {
                                                                                            const familyId = currentRow.familyId;
                                                                                            updatedRows = updatedRows.filter((row, i) => 
                                                                                                i === index || row.familyId !== familyId
                                                                                            );
                                                                                        }
                                                                                        
                                                                                        const rowIndex = updatedRows.findIndex(r => r.id === currentRow.id);
                                                                                        
                                                                                        if (rowIndex !== -1) {
                                                                                            const row = updatedRows[rowIndex];
                                                                                            row.selectedOption = newValue;
                                                                                            row.isModifying = false;
                                                                                            row.isFamilyRow = false;
                                                                                            row.familyId = null;
                                                                                            row.partId = newValue.part.id;
                                                                                            
                                                                                            // Set vendor and pricing information
                                                                                            const purchasingPart = this.state.parts.find(x => x.part.id === newValue.part.id);
                                                                                            if (purchasingPart) {
                                                                                                const vendorPart = purchasingPart.part.vendorParts.find(x => x.vendorId === purchasingPart.part.selectedVendorId) || purchasingPart.part.vendorParts[0];
                                                                                                const vendorName = vendorPart ? this.state.vendors.find(x => x.id === vendorPart.vendorId)?.name : '';
                                                                                                let initialPrice = 0;
                                                                                                let initialQuantity = 1;

                                                                                                if (vendorPart) {
                                                                                                    if (vendorPart.costType === 0 && vendorPart.tieredCostFormulas?.length) {
                                                                                                        const tierPrice = getTieredUnitPriceForQuantity(vendorPart, initialQuantity);
                                                                                                        initialPrice = tierPrice ?? 0;
                                                                                                    } else {
                                                                                                        initialPrice = normalizeUnitCost(vendorPart.basePrice / vendorPart.quantity);
                                                                                                        initialQuantity = vendorPart.quantity || initialQuantity;
                                                                                                    }
                                                                                                }

                                                                                                row.vendor = vendorName;
                                                                                                row.vendorId = vendorPart?.vendorId;
                                                                                                row.price = normalizeUnitCost(initialPrice);
                                                                                                row.total = calculateLineTotal(initialPrice, initialQuantity);
                                                                                                row.partQuantity = initialQuantity;
                                                                                                row.vendorParts = purchasingPart.part.vendorParts;
                                                                                            }
                                                                                        }
                                                                                        
                                                                                        this.setState({ newLogParts: updatedRows }, () => {
                                                                                            // After state update for individual part, focus the quantity field
                                                                                            setTimeout(() => {
                                                                                                const allQuantityInputs = document.querySelectorAll(`input[data-field-type="part-quantity"]`);
                                                                                                if (allQuantityInputs.length > 0) {
                                                                                                    let quantityInput = document.querySelector(`input[data-row-index="${rowIndex}"][data-field-type="part-quantity"]`);
                                                                                                    if (!quantityInput && allQuantityInputs.length > rowIndex) {
                                                                                                        quantityInput = allQuantityInputs[rowIndex];
                                                                                                    }
                                                                                                    if (quantityInput) {
                                                                                                        quantityInput.focus();
                                                                                                        quantityInput.select();
                                                                                                    }
                                                                                                }
                                                                                            }, 150);
                                                                                        });
                                                                                    }
                                                                                }}
                                                                                renderOption={(option) => <PartAutocompleteOption option={option} classes={this.props.classes} />}
                                                                                renderInput={(params) => <TextField {...params} variant="outlined" 
                                                                    inputProps={{ 
                                                                        ...params.inputProps,
                                                                        tabIndex: index * 4 + 1,
                                                                        'data-row-index': index,
                                                                        'data-field-type': 'part-number'
                                                                    }}
                                                                    onKeyDown={(event) => {
                                                                        if (event.key === 'Enter') {
                                                                            // Focus the family quantity field when Enter is pressed
                                                                            setTimeout(() => {
                                                                                const quantityInput = document.querySelector(`input[data-row-index="${index}"][data-field-type="family-quantity"]`);
                                                                                if (quantityInput) {
                                                                                    quantityInput.focus();
                                                                                    quantityInput.select();
                                                                                }
                                                                            }, 100);
                                                                        }
                                                                    }}
                                                                />}
                                                                            />
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        <TextField
                                                                            type="number"
                                                                            value={getNumberInputDisplayValue(row.familyQuantity)}
                                                                            onChange={(event) => this.handleFamilyQuantityChange(event, index)}
                                                                            variant="outlined"
                                                                            style={{width: '75%'}}
                                                            inputProps={{ 
                                                                tabIndex: index * 4 + 2,
                                                                'data-row-index': index,
                                                                'data-field-type': 'family-quantity'
                                                            }}
                                                            onKeyDown={(event) => this.handleQuantityKeyDown(event, index)}
                                                                            autoComplete="off"
                                                                        />
                                                                    </td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td>
                                                                        <FontAwesomeIcon
                                                                            icon={faTrash}
                                                                            style={{ cursor: 'pointer', color: 'black' }}
                                                                            onClick={() => this.removeLine(index)}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            );
                                                        } else {
                                                            console.log(`Rendering individual part ${row.partId} - isFamilyPart: ${row.isFamilyPart}, selectedOption:`, row.selectedOption);
                                                            const partExpanded = this.state.parts.find(x => x.part.id === (row.selectedOption?.part?.id || row.partId));
                                                            return (
                                                                <tr key={row.id} style={{backgroundColor: row.isFamilyPart ? '#f5f5f5' : 'inherit'}}>
                                                                    <td className="text-left">
                                                                        {row.selectedOption && !row.isModifying ? (
                                                                            <div style={{cursor: 'pointer'}} onClick={() => this.handlePartDisplayClick(index)}>
                                                                                <PartDisplay 
                                                                                    part={row.selectedOption?.part?.part || partExpanded?.part || {
                                                                                        partId: 'Unknown Part',
                                                                                        revision: '',
                                                                                        description: ''
                                                                                    }}
                                                                                    debug={console.log('PartDisplay for individual part', row.partId, ':', {
                                                                                        selectedOption: row.selectedOption,
                                                                                        partData: row.selectedOption?.part || partExpanded?.part,
                                                                                        finalPart: row.selectedOption?.part || partExpanded?.part || {
                                                                                            partId: 'Unknown Part',
                                                                                            revision: '',
                                                                                            description: ''
                                                                                        }
                                                                                    })}
                                                                                    variant="table"
                                                                                    classes={this.props.classes}
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            <Autocomplete autoHighlight
                                                                                options={partsOptions}
                                                                                getOptionLabel={(option) => option.title || ''}
                                                                                value={row.selectedOption}
                                                                                onChange={(event, newValue) => {
                                                                                    // Check if the new value is a family or an individual part
                                                                                    if (newValue && newValue.isFamily) {
                                                                                        // Converting to a family, use handleFamilyChange
                                                                                        this.handleFamilyChange(event, newValue, index);
                                                                                        setTimeout(() => {
                                                                                            const updatedRows = [...this.state.newLogParts];
                                                                                            updatedRows[index].isModifying = false;
                                                                                            this.setState({ newLogParts: updatedRows });
                                                                                        }, 0);
                                                                                    } else if (newValue && newValue.part) {
                                                                                        // It's an individual part
                                                                                        let updatedRows = [...this.state.newLogParts];
                                                                                        const currentRow = updatedRows[index];
                                                                                        
                                                                                        // If this row had child parts (was a family), remove them
                                                                                        if (currentRow.familyId) {
                                                                                            const familyId = currentRow.familyId;
                                                                                            updatedRows = updatedRows.filter((row, i) => 
                                                                                                i === index || row.familyId !== familyId
                                                                                            );
                                                                                        }
                                                                                        
                                                                                        // Find the row again after filtering
                                                                                        const rowIndex = updatedRows.findIndex(r => r.id === currentRow.id);
                                                                                        
                                                                                        if (rowIndex !== -1) {
                                                                                            const row = updatedRows[rowIndex];
                                                                                            row.selectedOption = newValue;
                                                                                            row.isModifying = false;
                                                                                            row.isFamilyRow = false;
                                                                                            row.familyId = null;
                                                                                            row.partId = newValue.part.id;
                                                                                            
                                                                                            // Set vendor and pricing information
                                                                                            const purchasingPart = this.state.parts.find(x => x.part.id === newValue.part.id);
                                                                                            if (purchasingPart) {
                                                                                                const vendorPart = purchasingPart.part.vendorParts.find(x => x.vendorId === purchasingPart.part.selectedVendorId) || purchasingPart.part.vendorParts[0];
                                                                                                const vendorName = vendorPart ? this.state.vendors.find(x => x.id === vendorPart.vendorId)?.name : '';
                                                                                                let initialPrice = 0;
                                                                                                let initialQuantity = 1;

                                                                                                if (vendorPart) {
                                                                                                    if (vendorPart.costType === 0 && vendorPart.tieredCostFormulas?.length) {
                                                                                                        const tierPrice = getTieredUnitPriceForQuantity(vendorPart, initialQuantity);
                                                                                                        initialPrice = tierPrice ?? 0;
                                                                                                    } else {
                                                                                                        initialPrice = normalizeUnitCost(vendorPart.basePrice / vendorPart.quantity);
                                                                                                        initialQuantity = vendorPart.quantity || initialQuantity;
                                                                                                    }
                                                                                                }

                                                                                                row.vendor = vendorName;
                                                                                                row.vendorId = vendorPart?.vendorId;
                                                                                                row.price = normalizeUnitCost(initialPrice);
                                                                                                row.total = calculateLineTotal(initialPrice, initialQuantity);
                                                                                                row.partQuantity = initialQuantity;
                                                                                                row.vendorParts = purchasingPart.part.vendorParts;
                                                                                            }
                                                                                        }
                                                                                        
                                                                                        this.setState({ newLogParts: updatedRows }, () => {
                                                                                            // After state update, focus the quantity field for the updated row
                                                                                            setTimeout(() => {
                                                                                                const allQuantityInputs = document.querySelectorAll(`input[data-field-type="part-quantity"]`);
                                                                                                if (allQuantityInputs.length > 0) {
                                                                                                    let quantityInput = document.querySelector(`input[data-row-index="${rowIndex}"][data-field-type="part-quantity"]`);
                                                                                                    if (!quantityInput && allQuantityInputs.length > rowIndex) {
                                                                                                        quantityInput = allQuantityInputs[rowIndex];
                                                                                                    }
                                                                                                    if (quantityInput) {
                                                                                                        quantityInput.focus();
                                                                                                        quantityInput.select();
                                                                                                    }
                                                                                                }
                                                                                            }, 150);
                                                                                        });
                                                                                    }
                                                                                }}
                                                                                renderInput={(params) => (
                                                                                    <TextField
                                                                                        {...params}
                                                                                        variant="outlined"
                                                                                        placeholder="Select Part"
                                                                                    />
                                                                                )}
                                                                                renderOption={(option) => (
                                                                                    <PartAutocompleteOption
                                                                                        option={option}
                                                                                        variant="part"
                                                                                    />
                                                                                )}
                                                                            />
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        <TextField
                                                                            type="number"
                                                                            value={getNumberInputDisplayValue(row.partQuantity)}
                                                                            onChange={(event) => this.handlePartQuantityChange(event, index)}
                                                                            variant="outlined"
                                                                            style={{width: '75%'}}
                                                            inputProps={{ 
                                                                tabIndex: index * 4 + 2,
                                                                'data-row-index': index,
                                                                'data-field-type': 'part-quantity'
                                                            }}
                                                            onKeyDown={(event) => this.handleQuantityKeyDown(event, index)}
                                                                            autoComplete="off"
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        {row.vendorParts && row.vendorParts.length > 0 ? (
                                                                            <FormControl variant="outlined" style={{minWidth: 150}}>
                                                                                <Select
                                                                                    value={row.vendorId || ''}
                                                                                    onChange={(event) => this.handleVendorChange(event, index)}
                                                                    inputProps={{ 
                                                                        tabIndex: -1,
                                                                        'data-row-index': index,
                                                                        'data-field-type': 'vendor'
                                                                    }}
                                                                                >
                                                                                    {row.vendorParts.map((vendorPart) => {
                                                                                        const vendor = this.state.vendors.find(x => x.id === vendorPart.vendorId);
                                                                                        return (
                                                                                            <MenuItem key={vendorPart.vendorId} value={vendorPart.vendorId}>
                                                                                                {vendor?.name}
                                                                                            </MenuItem>
                                                                                        );
                                                                                    })}
                                                                                </Select>
                                                                            </FormControl>
                                                                        ) : (
                                                                            row.vendor || ''
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                                                            <TextField
                                                                                type="number"
                                                                                value={getNumberInputDisplayValue(row.price)}
                                                                                onChange={(event) => this.handlePartPriceChange(event, index)}

                                                                                variant="outlined"
                                                                                style={{width: '75%'}}
                                                                                InputProps={{
                                                                                    startAdornment: <span style={{marginRight: 8}}>$</span>
                                                                                }}
                                                                inputProps={{ 
                                                                    tabIndex: -1,
                                                                    'data-row-index': index,
                                                                    'data-field-type': 'price'
                                                                }}
                                                                                autoComplete="off"
                                                                            />
                                                                            {row.vendorParts?.find(vp => vp.vendorId === row.vendorId)?.costType === 0 && (
                                                                                <FontAwesomeIcon 
                                                                                    icon={faInfoCircle} 
                                                                                    style={{ cursor: 'help' }}
                                                                                    title={this.getTieredPricingTooltip(row.vendorParts.find(vp => vp.vendorId === row.vendorId))}
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                    <td>${(row.total || 0).toFixed(2)}</td>
                                                                    <td>
                                                                        <FontAwesomeIcon
                                                                            icon={faTrash}
                                                                            style={{ cursor: 'pointer', color: 'black' }}
                                                                            onClick={() => this.removeLine(index)}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                    })}
                                                    <tr style={{backgroundColor: '#f0f0f0', fontWeight: 'bold'}}>
                                                        <td colSpan={5} style={{textAlign: 'right'}}>Total:</td>
                                                        <td>
                                                            ${this.state.newLogParts
                                                                .filter(row => !row.isFamilyRow)
                                                                .reduce((sum, row) => sum + (row.total || 0), 0)
                                                                .toFixed(2)}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <center>
                                            <Button 
                                                variant="contained"
                                                color="primary"
                                                onClick={this.addNewLine}
                                                className="success-button-lg" 
                                                style={{margin: '20px 0'}}
                                            >
                                                Add Line
                                            </Button>
                                            <br/>
                                            {this.state.savingPurchaseLog ?
                                                <CircularProgress/>
                                                :
                                                <Button 
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={this.submitPurchaseOrder}
                                                    className="success-button-lg"
                                                >
                                                    Submit Purchase Orders
                                                </Button>
                                            }
                                        </center>
                                    </div>
                                </DrawerMenuRight>
                            </div>
                        }
                    </div>
                </div>

                {/* Copy Table Dialog */}
                <Dialog 
                    open={this.state.showCopyTable} 
                    onClose={this.closeCopyTable}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle>
                        Copy Tables for Email
                    </DialogTitle>
                    <DialogContent style={{textAlign: 'center'}}>
                        {Object.entries(this.state.copyTablesByVendor).map(([vendor, tableData], vendorIndex) => (
                            <div key={vendor} style={{marginBottom: vendorIndex < Object.keys(this.state.copyTablesByVendor).length - 1 ? '30px' : '0px'}}>
                                <h3 style={{
                                    margin: '0 0 10px 0',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    color: '#333'
                                }}>
                                    {vendor}
                                </h3>
                                <table style={{
                                    width: '100%',
                                    maxWidth: '300px',
                                    margin: '10px auto',
                                    borderCollapse: 'collapse',
                                    border: '1px solid black',
                                    fontFamily: 'Arial, sans-serif',
                                    fontSize: '12px'
                                }}>
                                    <thead>
                                        <tr>
                                            <th style={{
                                                border: '1px solid black',
                                                padding: '8px',
                                                backgroundColor: '#f0f0f0',
                                                textAlign: 'center'
                                            }}>
                                                Quantity
                                            </th>
                                            <th style={{
                                                border: '1px solid black',
                                                padding: '8px',
                                                backgroundColor: '#f0f0f0',
                                                textAlign: 'center'
                                            }}>
                                                Item
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tableData.map((item, index) => (
                                            <tr key={index}>
                                                <td style={{
                                                    border: '1px solid black',
                                                    padding: '8px',
                                                    textAlign: 'center'
                                                }}>
                                                    {item.quantity}
                                                </td>
                                                <td style={{
                                                    border: '1px solid black',
                                                    padding: '8px',
                                                    textAlign: 'left'
                                                }}>
                                                    {item.partNumber} rev {item.revision}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div style={{textAlign: 'center', marginBottom: '10px'}}>
                                    <Button 
                                        onClick={() => this.copyVendorTableToClipboard(vendor, tableData)} 
                                        color="primary" 
                                        variant="contained"
                                        size="small"
                                    >
                                        Copy {vendor} Table
                                    </Button>
                                </div>
                            </div>
                        ))}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.closeCopyTable} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Session Drawer */}
                <DrawerMenuRight title="Start Inventory Session" customWidth={400}
                                open={this.state.sessionDrawerOpen}
                                onClose={this.closeSessionDrawer}>
                    <div style={{padding: '20px'}}>
                        {this.state.loadingNextSessionId ? (
                            <div style={{textAlign: 'center', padding: '20px'}}>
                                <CircularProgress />
                                <Typography variant="body1" style={{marginTop: '10px'}}>
                                    Finding next session number...
                                </Typography>
                            </div>
                        ) : (
                            <>
                                <Typography variant="body1" style={{marginBottom: '20px'}}>
                                    Start a new inventory session. This will create a shared workspace for tracking inventory adjustments.
                                </Typography>
                                
                                <TextField
                                    label="Session Number"
                                    variant="outlined"
                                    value={this.state.sessionNumber}
                                    onChange={this.handleSessionNumberChange}
                                    type="number"
                                    fullWidth
                                    style={{marginBottom: '20px'}}
                                    inputProps={{ min: 1 }}
                                />
                                
                                <div style={{textAlign: 'center'}}>
                                    <Button 
                                        variant="contained"
                                        color="primary"
                                        onClick={this.startSession}
                                        className="success-button-lg"
                                        style={{minWidth: 150}}
                                    >
                                        Start Session
                                    </Button>
                                </div>
                            </>
                        )}
                    </div>
                </DrawerMenuRight>
            </DashboardTemplate>
        );
    }
}

let globalProps;

AdminInventory.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminInventory);
